/*eslint no-undef: "error"*/
<template>
  <div>
    <div class="marker">
      <ul class="rigth">
        <li>
          <a href="#!" v-side-nav:demo="nav" class="sizeA stroke">
            <i class="material-icons dp48 fa-3x">apps</i> <br>
            <span>Menu</span>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <v-side-nav id="demo">
        <div class="container">
          <p>Antiguedad <small>Trimeste no. {{ trimestre }}</small></p>
          <p class="range-field">
            <input type="range" v-model="trimestre" id="test5" min="0" :max="rangoTrimestres" />
          </p>
          <p>Último servicio <small>Trimeste no. {{ trimestreServicio }}</small></p>
          <p class="range-field">
            <input type="range" v-model="trimestreServicio" id="test5" min="0" :max="rangoTrimestres" :disabled="todasFechas" />
          </p>
           <label for="zonas">Zonas</label>
           <multiselect v-model="zonasSelected" selectedLabel="seleccionado" selectLabel="Seleccionar" :options="itemsZonas" :multiple="true" :close-on-select="false" :clear-on-select="false" :hide-selected="true" :preserve-search="true" placeholder="Seleccionar Zona" label="name" track-by="name" :preselect-first="false">
              <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.name }} </span><span style="font-size:9px; cursor: pointer;" class="custom__remove" @click="props.remove(props.option)">❌</span></span><br></template>
           </multiselect>
            <label for="select">Mensaje predefinido</label>
            <v-select name="select"
                      id="select"
                      v-model="mensajePredefinido"
                      select-text="Seleccionar Mensaje"
                      :preselect-first="true"
                      :items="itemsPredefinido"
            ></v-select>
            <br>
           <label for="ta">Mensaje</label>
           <textarea rows="10" style="border: 1px solid #26a69a;" name="ta" id="ta" v-on:keyup="countdown" v-model="message"></textarea>
          <p class='right-align'>{{remainingCount}}</p>
          <label for="prueba">Es una prueba</label>
            <div class="switch">
              <label>
                No
                <input type="checkbox" v-model="prueba">
                <span class="lever"></span>
                Si
              </label>
            </div>
            <br>
            <label for="celular"># celular</label>
            <input name="celular"
              type="text"
              id="celular"
              v-model="celular"/>
            <br>
          <button @click="examinarUsuarios" style="width: 100%;" class="btn btn-block btn-info" type="submit">Enviar</button>
        </div>
      </v-side-nav>
      <gmap-map :center="center" ref="myMapService" :options="{streetViewControl: false}" :zoom="zoom" class="sinNav">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      <gmap-marker
        :key="i + 'mensajero'"
        v-for="(m, i) in mensajeros"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
    </div>
    <notifications group="foo" position="bottom left" />
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
require('../assets/multiselect.css')
import Multiselect from 'vue-multiselect'
import router from '../router'
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import { loaded } from 'vue2-google-maps'
import areaMetro from '../assets/AreaMetro.json'

export default {
  name: 'servicio',
  data () {
    return {
      areaMetroJson: areaMetro,
      nav: {
        edge: 'right'
      },
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      rangoTrimestres: 0,
      todasFechas: true,
      mensajePredefinido: 1,
      infoWinOpen: false,
      currentMidx: null,
      prueba: false,
      celular: null,
      zonasSelected: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajeros: [],
      usuarios: [],
      itemsPredefinido: [
        {
          text: 'Ningun mensaje',
          id: 1
        },
        {
          text: 'Usuarios nuevos',
          id: 2
        },
        {
          text: 'Usuarios mediana antigüedad',
          id: 3
        },
        {
          text: 'Usuarios antiguos',
          id: 4
        },
        {
          text: 'Ultimo servicio reciente',
          id: 5
        },
        {
          text: 'Ultimo servicio mediana antigüedad',
          id: 6
        },
        {
          text: 'Ultimo servicio antiguo',
          id: 7
        }
      ],
      user: {},
      maxCount: 160,
      remainingCount: 160,
      message: '',
      trimestre: 1,
      trimestreServicio: 0,
      kmlAreaMetropolitana: null,
      hasError: false,
      itemsZonas: [
        {
          name: 'Zona Laureles',
          value: 1
        },
        {
          name: 'Zona Centro',
          value: 2
        },
        {
          name: 'Zona Poblado',
          value: 3
        },
        {
          name: 'Zona Envigado',
          value: 4
        },
        {
          name: 'Area Metropolitana',
          value: 5
        }
      ],
      zonaLaureles: [
        {
          lng: -75.579747,
          lat: 6.2508963
        },
        {
          lng: -75.5808198,
          lat: 6.2515682
        },
        {
          lng: -75.5814207,
          lat: 6.2521654
        },
        {
          lng: -75.5820644,
          lat: 6.2526453
        },
        {
          lng: -75.5829442,
          lat: 6.2528906
        },
        {
          lng: -75.5839419,
          lat: 6.2529653
        },
        {
          lng: -75.5850363,
          lat: 6.2526667
        },
        {
          lng: -75.5858624,
          lat: 6.2526453
        },
        {
          lng: -75.5865061,
          lat: 6.253072
        },
        {
          lng: -75.5869138,
          lat: 6.2531999
        },
        {
          lng: -75.5895317,
          lat: 6.2531573
        },
        {
          lng: -75.5907762,
          lat: 6.2534452
        },
        {
          lng: -75.5920851,
          lat: 6.2539891
        },
        {
          lng: -75.5930722,
          lat: 6.2545117
        },
        {
          lng: -75.593909,
          lat: 6.2556849
        },
        {
          lng: -75.5950999,
          lat: 6.2551516
        },
        {
          lng: -75.5964625,
          lat: 6.2548957
        },
        {
          lng: -75.5972028,
          lat: 6.2546824
        },
        {
          lng: -75.5977714,
          lat: 6.2543731
        },
        {
          lng: -75.5983829,
          lat: 6.2535412
        },
        {
          lng: -75.5990911,
          lat: 6.2523467
        },
        {
          lng: -75.5997562,
          lat: 6.2513762
        },
        {
          lng: -75.5998099,
          lat: 6.2508856
        },
        {
          lng: -75.5997241,
          lat: 6.2502137
        },
        {
          lng: -75.6003463,
          lat: 6.2501924
        },
        {
          lng: -75.6009471,
          lat: 6.250491
        },
        {
          lng: -75.6019664,
          lat: 6.2505443
        },
        {
          lng: -75.6022775,
          lat: 6.2499578
        },
        {
          lng: -75.6023741,
          lat: 6.2493499
        },
        {
          lng: -75.6024814,
          lat: 6.248358
        },
        {
          lng: -75.6025887,
          lat: 6.2468116
        },
        {
          lng: -75.6027174,
          lat: 6.2450305
        },
        {
          lng: -75.6028354,
          lat: 6.2425562
        },
        {
          lng: -75.6029427,
          lat: 6.2403484
        },
        {
          lng: -75.60305,
          lat: 6.2382154
        },
        {
          lng: -75.6031251,
          lat: 6.2372555
        },
        {
          lng: -75.6027281,
          lat: 6.2364769
        },
        {
          lng: -75.6022775,
          lat: 6.2358797
        },
        {
          lng: -75.6022024,
          lat: 6.2341199
        },
        {
          lng: -75.6021595,
          lat: 6.2318695
        },
        {
          lng: -75.6020737,
          lat: 6.2311869
        },
        {
          lng: -75.6015158,
          lat: 6.2311122
        },
        {
          lng: -75.5981684,
          lat: 6.2313042
        },
        {
          lng: -75.5945528,
          lat: 6.2314535
        },
        {
          lng: -75.5914736,
          lat: 6.2315815
        },
        {
          lng: -75.5893385,
          lat: 6.2314749
        },
        {
          lng: -75.5880404,
          lat: 6.2315069
        },
        {
          lng: -75.5828047,
          lat: 6.2316349
        },
        {
          lng: -75.5791676,
          lat: 6.2317202
        },
        {
          lng: -75.5775905,
          lat: 6.2318162
        },
        {
          lng: -75.5768502,
          lat: 6.2316349
        },
        {
          lng: -75.575906,
          lat: 6.2314322
        },
        {
          lng: -75.5759275,
          lat: 6.2321788
        },
        {
          lng: -75.5760241,
          lat: 6.2336293
        },
        {
          lng: -75.5760777,
          lat: 6.2344185
        },
        {
          lng: -75.5766678,
          lat: 6.2364449
        },
        {
          lng: -75.5770433,
          lat: 6.2376181
        },
        {
          lng: -75.5777621,
          lat: 6.2396552
        },
        {
          lng: -75.5785561,
          lat: 6.2419376
        },
        {
          lng: -75.5795646,
          lat: 6.2449452
        },
        {
          lng: -75.5802727,
          lat: 6.2469395
        },
        {
          lng: -75.5805516,
          lat: 6.2478781
        },
        {
          lng: -75.5804658,
          lat: 6.2487633
        },
        {
          lng: -75.5800903,
          lat: 6.2494992
        },
        {
          lng: -75.5797255,
          lat: 6.2505977
        },
        {
          lng: -75.579747,
          lat: 6.2508963
        }
      ],
      zonaCentro: [
        {
          lng: -75.575273,
          lat: 6.2462356
        },
        {
          lng: -75.5685997,
          lat: 6.243868
        },
        {
          lng: -75.5673981,
          lat: 6.243484
        },
        {
          lng: -75.5658317,
          lat: 6.2429508
        },
        {
          lng: -75.5642223,
          lat: 6.2422682
        },
        {
          lng: -75.563364,
          lat: 6.2415856
        },
        {
          lng: -75.5628705,
          lat: 6.2417989
        },
        {
          lng: -75.5624843,
          lat: 6.2421189
        },
        {
          lng: -75.5619907,
          lat: 6.2423962
        },
        {
          lng: -75.5612826,
          lat: 6.2423962
        },
        {
          lng: -75.5606604,
          lat: 6.2418842
        },
        {
          lng: -75.5601239,
          lat: 6.2421189
        },
        {
          lng: -75.5593514,
          lat: 6.2411377
        },
        {
          lng: -75.5586219,
          lat: 6.2403271
        },
        {
          lng: -75.5570555,
          lat: 6.2429508
        },
        {
          lng: -75.5561113,
          lat: 6.2447425
        },
        {
          lng: -75.5564547,
          lat: 6.2453611
        },
        {
          lng: -75.5569696,
          lat: 6.2461077
        },
        {
          lng: -75.5579996,
          lat: 6.2466622
        },
        {
          lng: -75.5579138,
          lat: 6.2470249
        },
        {
          lng: -75.5563045,
          lat: 6.2494778
        },
        {
          lng: -75.5566692,
          lat: 6.2498191
        },
        {
          lng: -75.5583215,
          lat: 6.2513549
        },
        {
          lng: -75.5625057,
          lat: 6.2548743
        },
        {
          lng: -75.5655313,
          lat: 6.2567514
        },
        {
          lng: -75.5689859,
          lat: 6.2574766
        },
        {
          lng: -75.5707884,
          lat: 6.2577965
        },
        {
          lng: -75.5717325,
          lat: 6.2571353
        },
        {
          lng: -75.5731487,
          lat: 6.2564527
        },
        {
          lng: -75.5750155,
          lat: 6.2542344
        },
        {
          lng: -75.575273,
          lat: 6.2462356
        }
      ],
      zonaPoblado: [
        {
          lng: -75.5745971,
          lat: 6.2328934
        },
        {
          lng: -75.5750906,
          lat: 6.2328827
        },
        {
          lng: -75.5751872,
          lat: 6.2324348
        },
        {
          lng: -75.5752945,
          lat: 6.2314109
        },
        {
          lng: -75.5756164,
          lat: 6.2286592
        },
        {
          lng: -75.5761743,
          lat: 6.2251182
        },
        {
          lng: -75.5764103,
          lat: 6.2231238
        },
        {
          lng: -75.5765069,
          lat: 6.2226118
        },
        {
          lng: -75.5769682,
          lat: 6.2194334
        },
        {
          lng: -75.5773973,
          lat: 6.2162124
        },
        {
          lng: -75.5777729,
          lat: 6.21345
        },
        {
          lng: -75.5781054,
          lat: 6.2109862
        },
        {
          lng: -75.5786419,
          lat: 6.2072958
        },
        {
          lng: -75.5788028,
          lat: 6.2061012
        },
        {
          lng: -75.5789852,
          lat: 6.2047679
        },
        {
          lng: -75.5791783,
          lat: 6.2035733
        },
        {
          lng: -75.5793071,
          lat: 6.2025814
        },
        {
          lng: -75.5794358,
          lat: 6.2016534
        },
        {
          lng: -75.5796075,
          lat: 6.2005975
        },
        {
          lng: -75.579747,
          lat: 6.1997975
        },
        {
          lng: -75.5799079,
          lat: 6.1990403
        },
        {
          lng: -75.5802298,
          lat: 6.197963
        },
        {
          lng: -75.5807662,
          lat: 6.1965764
        },
        {
          lng: -75.5812383,
          lat: 6.1951791
        },
        {
          lng: -75.5805945,
          lat: 6.1949658
        },
        {
          lng: -75.5789101,
          lat: 6.1946991
        },
        {
          lng: -75.5780196,
          lat: 6.1944005
        },
        {
          lng: -75.5773222,
          lat: 6.1938245
        },
        {
          lng: -75.5767322,
          lat: 6.1937392
        },
        {
          lng: -75.5764318,
          lat: 6.1939952
        },
        {
          lng: -75.5762172,
          lat: 6.1947098
        },
        {
          lng: -75.5757236,
          lat: 6.1952218
        },
        {
          lng: -75.5752194,
          lat: 6.1962137
        },
        {
          lng: -75.5748761,
          lat: 6.1957231
        },
        {
          lng: -75.5746722,
          lat: 6.1953391
        },
        {
          lng: -75.5741465,
          lat: 6.1950724
        },
        {
          lng: -75.5733526,
          lat: 6.1946778
        },
        {
          lng: -75.5727518,
          lat: 6.1944111
        },
        {
          lng: -75.5722797,
          lat: 6.1939312
        },
        {
          lng: -75.5719042,
          lat: 6.1936218
        },
        {
          lng: -75.5710888,
          lat: 6.1932272
        },
        {
          lng: -75.5707455,
          lat: 6.1932485
        },
        {
          lng: -75.5700588,
          lat: 6.1935898
        },
        {
          lng: -75.5698335,
          lat: 6.1935258
        },
        {
          lng: -75.5693936,
          lat: 6.1932805
        },
        {
          lng: -75.5686426,
          lat: 6.1928325
        },
        {
          lng: -75.5684066,
          lat: 6.1925979
        },
        {
          lng: -75.5679882,
          lat: 6.1922139
        },
        {
          lng: -75.5675483,
          lat: 6.1919153
        },
        {
          lng: -75.5668938,
          lat: 6.1916806
        },
        {
          lng: -75.5660033,
          lat: 6.1913606
        },
        {
          lng: -75.5656707,
          lat: 6.1910193
        },
        {
          lng: -75.5653059,
          lat: 6.190582
        },
        {
          lng: -75.5650806,
          lat: 6.1899847
        },
        {
          lng: -75.565027,
          lat: 6.1895047
        },
        {
          lng: -75.5650806,
          lat: 6.188918
        },
        {
          lng: -75.5648875,
          lat: 6.188566
        },
        {
          lng: -75.5646515,
          lat: 6.18831
        },
        {
          lng: -75.5642974,
          lat: 6.1878941
        },
        {
          lng: -75.5639005,
          lat: 6.1874781
        },
        {
          lng: -75.5632997,
          lat: 6.1869128
        },
        {
          lng: -75.5629349,
          lat: 6.1867634
        },
        {
          lng: -75.5623555,
          lat: 6.1868274
        },
        {
          lng: -75.5617654,
          lat: 6.1868701
        },
        {
          lng: -75.5615079,
          lat: 6.1873714
        },
        {
          lng: -75.5610144,
          lat: 6.1891847
        },
        {
          lng: -75.5608106,
          lat: 6.190038
        },
        {
          lng: -75.5604136,
          lat: 6.1912433
        },
        {
          lng: -75.5598021,
          lat: 6.1922139
        },
        {
          lng: -75.5595875,
          lat: 6.1926619
        },
        {
          lng: -75.5599844,
          lat: 6.1934832
        },
        {
          lng: -75.559845,
          lat: 6.1936858
        },
        {
          lng: -75.559212,
          lat: 6.1938352
        },
        {
          lng: -75.5591476,
          lat: 6.1940698
        },
        {
          lng: -75.558815,
          lat: 6.1950938
        },
        {
          lng: -75.5578172,
          lat: 6.196491
        },
        {
          lng: -75.5563903,
          lat: 6.198443
        },
        {
          lng: -75.5559611,
          lat: 6.1991256
        },
        {
          lng: -75.5557144,
          lat: 6.1996376
        },
        {
          lng: -75.555768,
          lat: 6.1999575
        },
        {
          lng: -75.5563259,
          lat: 6.2011628
        },
        {
          lng: -75.5563903,
          lat: 6.2014721
        },
        {
          lng: -75.5563474,
          lat: 6.2019628
        },
        {
          lng: -75.5561435,
          lat: 6.2023041
        },
        {
          lng: -75.5556285,
          lat: 6.2034453
        },
        {
          lng: -75.5555642,
          lat: 6.204096
        },
        {
          lng: -75.5554783,
          lat: 6.2051199
        },
        {
          lng: -75.5554032,
          lat: 6.2058558
        },
        {
          lng: -75.5549204,
          lat: 6.2067198
        },
        {
          lng: -75.5548883,
          lat: 6.2074451
        },
        {
          lng: -75.5548668,
          lat: 6.2092263
        },
        {
          lng: -75.5543947,
          lat: 6.2102929
        },
        {
          lng: -75.5542338,
          lat: 6.2108368
        },
        {
          lng: -75.5545342,
          lat: 6.2113488
        },
        {
          lng: -75.5560041,
          lat: 6.2122874
        },
        {
          lng: -75.5566907,
          lat: 6.212714
        },
        {
          lng: -75.5570233,
          lat: 6.213226
        },
        {
          lng: -75.5574739,
          lat: 6.2139939
        },
        {
          lng: -75.5578494,
          lat: 6.2144525
        },
        {
          lng: -75.558697,
          lat: 6.2146872
        },
        {
          lng: -75.5597699,
          lat: 6.2149112
        },
        {
          lng: -75.5608642,
          lat: 6.2151565
        },
        {
          lng: -75.5617011,
          lat: 6.2153271
        },
        {
          lng: -75.5625379,
          lat: 6.2155511
        },
        {
          lng: -75.563525,
          lat: 6.2159564
        },
        {
          lng: -75.5641043,
          lat: 6.2164364
        },
        {
          lng: -75.5643189,
          lat: 6.2168737
        },
        {
          lng: -75.5642867,
          lat: 6.217375
        },
        {
          lng: -75.5641901,
          lat: 6.2179829
        },
        {
          lng: -75.5643725,
          lat: 6.2182282
        },
        {
          lng: -75.5647051,
          lat: 6.2182176
        },
        {
          lng: -75.5655849,
          lat: 6.2181536
        },
        {
          lng: -75.5658746,
          lat: 6.2182602
        },
        {
          lng: -75.5660784,
          lat: 6.2184522
        },
        {
          lng: -75.5660892,
          lat: 6.2190495
        },
        {
          lng: -75.5662286,
          lat: 6.2195934
        },
        {
          lng: -75.5664217,
          lat: 6.220244
        },
        {
          lng: -75.5660999,
          lat: 6.2206067
        },
        {
          lng: -75.5655527,
          lat: 6.2208626
        },
        {
          lng: -75.565424,
          lat: 6.22114
        },
        {
          lng: -75.5653596,
          lat: 6.2214493
        },
        {
          lng: -75.5651987,
          lat: 6.2225052
        },
        {
          lng: -75.5649948,
          lat: 6.2235717
        },
        {
          lng: -75.565027,
          lat: 6.224073
        },
        {
          lng: -75.5651665,
          lat: 6.2247663
        },
        {
          lng: -75.5651665,
          lat: 6.2252675
        },
        {
          lng: -75.5648339,
          lat: 6.2258222
        },
        {
          lng: -75.5648661,
          lat: 6.2262701
        },
        {
          lng: -75.5651128,
          lat: 6.2266221
        },
        {
          lng: -75.5664754,
          lat: 6.2265687
        },
        {
          lng: -75.5667436,
          lat: 6.2268887
        },
        {
          lng: -75.5670655,
          lat: 6.2269847
        },
        {
          lng: -75.5673444,
          lat: 6.2268887
        },
        {
          lng: -75.5676019,
          lat: 6.2269527
        },
        {
          lng: -75.5679452,
          lat: 6.226814
        },
        {
          lng: -75.5685139,
          lat: 6.226814
        },
        {
          lng: -75.5685031,
          lat: 6.2270167
        },
        {
          lng: -75.5685568,
          lat: 6.227262
        },
        {
          lng: -75.568825,
          lat: 6.227486
        },
        {
          lng: -75.5686963,
          lat: 6.2278059
        },
        {
          lng: -75.5688465,
          lat: 6.2282432
        },
        {
          lng: -75.5688143,
          lat: 6.2287658
        },
        {
          lng: -75.5686533,
          lat: 6.2298857
        },
        {
          lng: -75.5688679,
          lat: 6.2312509
        },
        {
          lng: -75.5697691,
          lat: 6.2311869
        },
        {
          lng: -75.5702841,
          lat: 6.2313469
        },
        {
          lng: -75.5710566,
          lat: 6.2316242
        },
        {
          lng: -75.5721617,
          lat: 6.2320508
        },
        {
          lng: -75.5730629,
          lat: 6.2324561
        },
        {
          lng: -75.5742431,
          lat: 6.2329254
        },
        {
          lng: -75.5745971,
          lat: 6.2328934
        }
      ],
      zonaEnvigado: [
        {
          lng: -75.5817494,
          lat: 6.1936965
        },
        {
          lng: -75.5820322,
          lat: 6.1929499
        },
        {
          lng: -75.5823326,
          lat: 6.1916699
        },
        {
          lng: -75.5825686,
          lat: 6.1904113
        },
        {
          lng: -75.5830836,
          lat: 6.1888327
        },
        {
          lng: -75.5833411,
          lat: 6.188214
        },
        {
          lng: -75.5838346,
          lat: 6.1875954
        },
        {
          lng: -75.5851007,
          lat: 6.1866994
        },
        {
          lng: -75.5865598,
          lat: 6.1855901
        },
        {
          lng: -75.587976,
          lat: 6.1842462
        },
        {
          lng: -75.5891132,
          lat: 6.1828169
        },
        {
          lng: -75.5908298,
          lat: 6.1801716
        },
        {
          lng: -75.5916238,
          lat: 6.1789129
        },
        {
          lng: -75.5924928,
          lat: 6.1776863
        },
        {
          lng: -75.593555,
          lat: 6.176577
        },
        {
          lng: -75.5950356,
          lat: 6.175489
        },
        {
          lng: -75.5972457,
          lat: 6.173953
        },
        {
          lng: -75.5970204,
          lat: 6.1737183
        },
        {
          lng: -75.5968273,
          lat: 6.1736117
        },
        {
          lng: -75.5955935,
          lat: 6.1727157
        },
        {
          lng: -75.5946386,
          lat: 6.1719797
        },
        {
          lng: -75.5945098,
          lat: 6.1717237
        },
        {
          lng: -75.5944669,
          lat: 6.1714143
        },
        {
          lng: -75.5945742,
          lat: 6.1712757
        },
        {
          lng: -75.5950356,
          lat: 6.1708597
        },
        {
          lng: -75.5953896,
          lat: 6.1704543
        },
        {
          lng: -75.5953467,
          lat: 6.1701877
        },
        {
          lng: -75.5952179,
          lat: 6.1698677
        },
        {
          lng: -75.5949605,
          lat: 6.169601
        },
        {
          lng: -75.594542,
          lat: 6.1691957
        },
        {
          lng: -75.5940592,
          lat: 6.1689823
        },
        {
          lng: -75.5931902,
          lat: 6.1686837
        },
        {
          lng: -75.5913234,
          lat: 6.1682677
        },
        {
          lng: -75.5902612,
          lat: 6.168001
        },
        {
          lng: -75.5904329,
          lat: 6.1677023
        },
        {
          lng: -75.5904973,
          lat: 6.167489
        },
        {
          lng: -75.5909586,
          lat: 6.1670196
        },
        {
          lng: -75.5908835,
          lat: 6.166785
        },
        {
          lng: -75.5907333,
          lat: 6.1664223
        },
        {
          lng: -75.5909264,
          lat: 6.1656116
        },
        {
          lng: -75.5908513,
          lat: 6.1651316
        },
        {
          lng: -75.5905294,
          lat: 6.1645663
        },
        {
          lng: -75.5900145,
          lat: 6.1651743
        },
        {
          lng: -75.5896497,
          lat: 6.164769
        },
        {
          lng: -75.5891991,
          lat: 6.1642036
        },
        {
          lng: -75.5886304,
          lat: 6.1648116
        },
        {
          lng: -75.5876756,
          lat: 6.1655796
        },
        {
          lng: -75.5871499,
          lat: 6.1649716
        },
        {
          lng: -75.5866241,
          lat: 6.1643636
        },
        {
          lng: -75.586313,
          lat: 6.1637876
        },
        {
          lng: -75.5856049,
          lat: 6.1618569
        },
        {
          lng: -75.5854762,
          lat: 6.1619102
        },
        {
          lng: -75.585165,
          lat: 6.1621129
        },
        {
          lng: -75.5848861,
          lat: 6.1625289
        },
        {
          lng: -75.5847037,
          lat: 6.1624969
        },
        {
          lng: -75.5843604,
          lat: 6.1621556
        },
        {
          lng: -75.5840278,
          lat: 6.1618462
        },
        {
          lng: -75.5838025,
          lat: 6.1616436
        },
        {
          lng: -75.5834699,
          lat: 6.1616649
        },
        {
          lng: -75.5831909,
          lat: 6.1616969
        },
        {
          lng: -75.582633,
          lat: 6.1621022
        },
        {
          lng: -75.5820537,
          lat: 6.1630516
        },
        {
          lng: -75.5816031,
          lat: 6.1639156
        },
        {
          lng: -75.5814314,
          lat: 6.1638729
        },
        {
          lng: -75.5808842,
          lat: 6.1638516
        },
        {
          lng: -75.5808842,
          lat: 6.1644063
        },
        {
          lng: -75.5808735,
          lat: 6.1649183
        },
        {
          lng: -75.5805838,
          lat: 6.1647903
        },
        {
          lng: -75.5802834,
          lat: 6.164929
        },
        {
          lng: -75.5801976,
          lat: 6.1652276
        },
        {
          lng: -75.5802512,
          lat: 6.1657076
        },
        {
          lng: -75.579865,
          lat: 6.1659423
        },
        {
          lng: -75.5792212,
          lat: 6.165857
        },
        {
          lng: -75.5786955,
          lat: 6.165633
        },
        {
          lng: -75.5779874,
          lat: 6.165537
        },
        {
          lng: -75.5775797,
          lat: 6.1658676
        },
        {
          lng: -75.5770111,
          lat: 6.1662836
        },
        {
          lng: -75.5763888,
          lat: 6.1659956
        },
        {
          lng: -75.5757987,
          lat: 6.1654943
        },
        {
          lng: -75.5750585,
          lat: 6.1650143
        },
        {
          lng: -75.5745006,
          lat: 6.1648863
        },
        {
          lng: -75.5742967,
          lat: 6.1651423
        },
        {
          lng: -75.5738568,
          lat: 6.1655583
        },
        {
          lng: -75.5739212,
          lat: 6.165985
        },
        {
          lng: -75.5738783,
          lat: 6.166337
        },
        {
          lng: -75.573771,
          lat: 6.1666143
        },
        {
          lng: -75.5738676,
          lat: 6.1668383
        },
        {
          lng: -75.5738676,
          lat: 6.167393
        },
        {
          lng: -75.5734599,
          lat: 6.1672756
        },
        {
          lng: -75.5724621,
          lat: 6.167393
        },
        {
          lng: -75.5718076,
          lat: 6.167489
        },
        {
          lng: -75.5713141,
          lat: 6.167393
        },
        {
          lng: -75.5707991,
          lat: 6.1673183
        },
        {
          lng: -75.5701876,
          lat: 6.1670623
        },
        {
          lng: -75.5692971,
          lat: 6.1669983
        },
        {
          lng: -75.5687606,
          lat: 6.1681503
        },
        {
          lng: -75.5683959,
          lat: 6.168961
        },
        {
          lng: -75.5684388,
          lat: 6.169633
        },
        {
          lng: -75.5685782,
          lat: 6.169985
        },
        {
          lng: -75.5685997,
          lat: 6.1704863
        },
        {
          lng: -75.5684924,
          lat: 6.171393
        },
        {
          lng: -75.5680203,
          lat: 6.1717023
        },
        {
          lng: -75.5679238,
          lat: 6.1720543
        },
        {
          lng: -75.5679131,
          lat: 6.1724597
        },
        {
          lng: -75.5676663,
          lat: 6.1728117
        },
        {
          lng: -75.5671942,
          lat: 6.1729823
        },
        {
          lng: -75.5665827,
          lat: 6.1730997
        },
        {
          lng: -75.566293,
          lat: 6.1732703
        },
        {
          lng: -75.5662179,
          lat: 6.173633
        },
        {
          lng: -75.5664754,
          lat: 6.1739317
        },
        {
          lng: -75.5667758,
          lat: 6.1743476
        },
        {
          lng: -75.5670333,
          lat: 6.1748276
        },
        {
          lng: -75.5669904,
          lat: 6.1755423
        },
        {
          lng: -75.5673015,
          lat: 6.1761183
        },
        {
          lng: -75.5676448,
          lat: 6.1765876
        },
        {
          lng: -75.567441,
          lat: 6.177281
        },
        {
          lng: -75.5673444,
          lat: 6.1780809
        },
        {
          lng: -75.5676877,
          lat: 6.1790943
        },
        {
          lng: -75.5676019,
          lat: 6.1792756
        },
        {
          lng: -75.5673552,
          lat: 6.1794356
        },
        {
          lng: -75.5671191,
          lat: 6.1793289
        },
        {
          lng: -75.5667436,
          lat: 6.1791156
        },
        {
          lng: -75.5661857,
          lat: 6.1794036
        },
        {
          lng: -75.5661321,
          lat: 6.1796169
        },
        {
          lng: -75.5662608,
          lat: 6.1805236
        },
        {
          lng: -75.5656385,
          lat: 6.1802782
        },
        {
          lng: -75.5655313,
          lat: 6.1803849
        },
        {
          lng: -75.5653274,
          lat: 6.1806836
        },
        {
          lng: -75.5654025,
          lat: 6.1810782
        },
        {
          lng: -75.5651343,
          lat: 6.1811529
        },
        {
          lng: -75.5644906,
          lat: 6.1821555
        },
        {
          lng: -75.5647373,
          lat: 6.1822942
        },
        {
          lng: -75.5647373,
          lat: 6.1825075
        },
        {
          lng: -75.5649304,
          lat: 6.1827209
        },
        {
          lng: -75.5653596,
          lat: 6.1829022
        },
        {
          lng: -75.5657566,
          lat: 6.1831369
        },
        {
          lng: -75.5660784,
          lat: 6.1834142
        },
        {
          lng: -75.5664647,
          lat: 6.1834248
        },
        {
          lng: -75.5665612,
          lat: 6.1835528
        },
        {
          lng: -75.566411,
          lat: 6.1841928
        },
        {
          lng: -75.5662286,
          lat: 6.1851848
        },
        {
          lng: -75.5664432,
          lat: 6.1855261
        },
        {
          lng: -75.5666792,
          lat: 6.1856435
        },
        {
          lng: -75.5678058,
          lat: 6.1857715
        },
        {
          lng: -75.5686748,
          lat: 6.1858141
        },
        {
          lng: -75.569061,
          lat: 6.1856221
        },
        {
          lng: -75.5693936,
          lat: 6.1856648
        },
        {
          lng: -75.5702198,
          lat: 6.1858888
        },
        {
          lng: -75.5709064,
          lat: 6.1858675
        },
        {
          lng: -75.5714965,
          lat: 6.1858461
        },
        {
          lng: -75.5717325,
          lat: 6.1859314
        },
        {
          lng: -75.572741,
          lat: 6.1864114
        },
        {
          lng: -75.5736423,
          lat: 6.1869128
        },
        {
          lng: -75.5742967,
          lat: 6.1873607
        },
        {
          lng: -75.5745113,
          lat: 6.1877341
        },
        {
          lng: -75.5747688,
          lat: 6.1883634
        },
        {
          lng: -75.5750155,
          lat: 6.1886194
        },
        {
          lng: -75.5753803,
          lat: 6.1889074
        },
        {
          lng: -75.5763674,
          lat: 6.1895473
        },
        {
          lng: -75.5771399,
          lat: 6.1897927
        },
        {
          lng: -75.5770218,
          lat: 6.1902193
        },
        {
          lng: -75.5766785,
          lat: 6.1912326
        },
        {
          lng: -75.5775046,
          lat: 6.1917446
        },
        {
          lng: -75.5779552,
          lat: 6.1920326
        },
        {
          lng: -75.5782878,
          lat: 6.1921926
        },
        {
          lng: -75.5785405,
          lat: 6.1922246
        },
        {
          lng: -75.5789911,
          lat: 6.1919472
        },
        {
          lng: -75.5795382,
          lat: 6.1913606
        },
        {
          lng: -75.5799352,
          lat: 6.1907313
        },
        {
          lng: -75.5802249,
          lat: 6.1906886
        },
        {
          lng: -75.5800854,
          lat: 6.1912006
        },
        {
          lng: -75.5799888,
          lat: 6.1920646
        },
        {
          lng: -75.5798601,
          lat: 6.1926406
        },
        {
          lng: -75.5800854,
          lat: 6.1929499
        },
        {
          lng: -75.5803546,
          lat: 6.1930565
        },
        {
          lng: -75.5807408,
          lat: 6.1931845
        },
        {
          lng: -75.5812344,
          lat: 6.1934619
        },
        {
          lng: -75.5817494,
          lat: 6.1936965
        }
      ],
      zonaMetro: [
        {
          lng: -75.4590797,
          lat: 6.3850773
        },
        {
          lng: -75.4607105,
          lat: 6.3853332
        },
        {
          lng: -75.4627705,
          lat: 6.3853332
        },
        {
          lng: -75.4658604,
          lat: 6.384992
        },
        {
          lng: -75.4694653,
          lat: 6.3843096
        },
        {
          lng: -75.4722977,
          lat: 6.3840537
        },
        {
          lng: -75.4751301,
          lat: 6.383286
        },
        {
          lng: -75.4780483,
          lat: 6.3823477
        },
        {
          lng: -75.4807949,
          lat: 6.3822624
        },
        {
          lng: -75.481739,
          lat: 6.3831154
        },
        {
          lng: -75.4825115,
          lat: 6.3843949
        },
        {
          lng: -75.482769,
          lat: 6.3855038
        },
        {
          lng: -75.4826832,
          lat: 6.386442
        },
        {
          lng: -75.4839706,
          lat: 6.3874656
        },
        {
          lng: -75.4855156,
          lat: 6.3866979
        },
        {
          lng: -75.4866314,
          lat: 6.3855038
        },
        {
          lng: -75.4877472,
          lat: 6.384139
        },
        {
          lng: -75.489378,
          lat: 6.3834566
        },
        {
          lng: -75.4909229,
          lat: 6.3836272
        },
        {
          lng: -75.4904938,
          lat: 6.3825183
        },
        {
          lng: -75.4905796,
          lat: 6.3809829
        },
        {
          lng: -75.4909229,
          lat: 6.3797887
        },
        {
          lng: -75.492382,
          lat: 6.3796181
        },
        {
          lng: -75.4940128,
          lat: 6.3796181
        },
        {
          lng: -75.492897,
          lat: 6.3782534
        },
        {
          lng: -75.4921246,
          lat: 6.3772298
        },
        {
          lng: -75.4927254,
          lat: 6.3764621
        },
        {
          lng: -75.4936695,
          lat: 6.3751826
        },
        {
          lng: -75.4946995,
          lat: 6.3757797
        },
        {
          lng: -75.4953003,
          lat: 6.3745855
        },
        {
          lng: -75.4982185,
          lat: 6.3757797
        },
        {
          lng: -75.500021,
          lat: 6.3746708
        },
        {
          lng: -75.5021667,
          lat: 6.3734766
        },
        {
          lng: -75.5031967,
          lat: 6.3726236
        },
        {
          lng: -75.50457,
          lat: 6.3719412
        },
        {
          lng: -75.5044842,
          lat: 6.3700645
        },
        {
          lng: -75.5031967,
          lat: 6.3689556
        },
        {
          lng: -75.5044842,
          lat: 6.3673349
        },
        {
          lng: -75.5059433,
          lat: 6.3663113
        },
        {
          lng: -75.5073166,
          lat: 6.3656289
        },
        {
          lng: -75.5079174,
          lat: 6.3646906
        },
        {
          lng: -75.5087757,
          lat: 6.3633257
        },
        {
          lng: -75.5104065,
          lat: 6.3618756
        },
        {
          lng: -75.5123806,
          lat: 6.3609373
        },
        {
          lng: -75.5135822,
          lat: 6.3612785
        },
        {
          lng: -75.5148697,
          lat: 6.3600843
        },
        {
          lng: -75.5158138,
          lat: 6.360852
        },
        {
          lng: -75.5163288,
          lat: 6.3592312
        },
        {
          lng: -75.516758,
          lat: 6.3563309
        },
        {
          lng: -75.5171871,
          lat: 6.3534306
        },
        {
          lng: -75.5182171,
          lat: 6.3511274
        },
        {
          lng: -75.5176163,
          lat: 6.3485683
        },
        {
          lng: -75.5177021,
          lat: 6.346521
        },
        {
          lng: -75.5201054,
          lat: 6.3456679
        },
        {
          lng: -75.5219078,
          lat: 6.3440472
        },
        {
          lng: -75.5235386,
          lat: 6.3432794
        },
        {
          lng: -75.5254269,
          lat: 6.342341
        },
        {
          lng: -75.5241394,
          lat: 6.3401231
        },
        {
          lng: -75.5255988,
          lat: 6.3386736
        },
        {
          lng: -75.5272293,
          lat: 6.3382464
        },
        {
          lng: -75.5303192,
          lat: 6.3383317
        },
        {
          lng: -75.5328083,
          lat: 6.3387582
        },
        {
          lng: -75.5340958,
          lat: 6.3390141
        },
        {
          lng: -75.5337524,
          lat: 6.340379
        },
        {
          lng: -75.5326366,
          lat: 6.3415733
        },
        {
          lng: -75.5325508,
          lat: 6.3427676
        },
        {
          lng: -75.5336666,
          lat: 6.3439618
        },
        {
          lng: -75.5338383,
          lat: 6.3452414
        },
        {
          lng: -75.5351257,
          lat: 6.3464357
        },
        {
          lng: -75.5368423,
          lat: 6.3479712
        },
        {
          lng: -75.5374432,
          lat: 6.3492507
        },
        {
          lng: -75.5384731,
          lat: 6.3490801
        },
        {
          lng: -75.5383015,
          lat: 6.3468622
        },
        {
          lng: -75.5387306,
          lat: 6.3454973
        },
        {
          lng: -75.5392456,
          lat: 6.3464357
        },
        {
          lng: -75.5404472,
          lat: 6.3469475
        },
        {
          lng: -75.541563,
          lat: 6.3474593
        },
        {
          lng: -75.542078,
          lat: 6.3489948
        },
        {
          lng: -75.5428505,
          lat: 6.3477153
        },
        {
          lng: -75.544138,
          lat: 6.3483124
        },
        {
          lng: -75.5462837,
          lat: 6.3489095
        },
        {
          lng: -75.548172,
          lat: 6.349592
        },
        {
          lng: -75.5493736,
          lat: 6.3500185
        },
        {
          lng: -75.5504036,
          lat: 6.3507862
        },
        {
          lng: -75.5511761,
          lat: 6.3518099
        },
        {
          lng: -75.5520344,
          lat: 6.3518099
        },
        {
          lng: -75.5530643,
          lat: 6.3501038
        },
        {
          lng: -75.5546093,
          lat: 6.3496773
        },
        {
          lng: -75.5555534,
          lat: 6.3499332
        },
        {
          lng: -75.5558109,
          lat: 6.3507862
        },
        {
          lng: -75.5573559,
          lat: 6.3510421
        },
        {
          lng: -75.558815,
          lat: 6.3511274
        },
        {
          lng: -75.5592442,
          lat: 6.3496773
        },
        {
          lng: -75.5606174,
          lat: 6.3501891
        },
        {
          lng: -75.5606174,
          lat: 6.3515539
        },
        {
          lng: -75.559845,
          lat: 6.3530041
        },
        {
          lng: -75.5604458,
          lat: 6.3553073
        },
        {
          lng: -75.5619049,
          lat: 6.3538571
        },
        {
          lng: -75.5626774,
          lat: 6.3522364
        },
        {
          lng: -75.5644798,
          lat: 6.3518099
        },
        {
          lng: -75.5661106,
          lat: 6.3523217
        },
        {
          lng: -75.5664539,
          lat: 6.3537718
        },
        {
          lng: -75.5661964,
          lat: 6.356075
        },
        {
          lng: -75.5668831,
          lat: 6.3572693
        },
        {
          lng: -75.5690289,
          lat: 6.3573546
        },
        {
          lng: -75.5710888,
          lat: 6.3566722
        },
        {
          lng: -75.5725479,
          lat: 6.355222
        },
        {
          lng: -75.5712605,
          lat: 6.3528335
        },
        {
          lng: -75.5701447,
          lat: 6.3509568
        },
        {
          lng: -75.5692005,
          lat: 6.3487389
        },
        {
          lng: -75.5698872,
          lat: 6.3472887
        },
        {
          lng: -75.5718613,
          lat: 6.347374
        },
        {
          lng: -75.5736637,
          lat: 6.3477153
        },
        {
          lng: -75.5749512,
          lat: 6.3468622
        },
        {
          lng: -75.574522,
          lat: 6.3458386
        },
        {
          lng: -75.5742645,
          lat: 6.3449002
        },
        {
          lng: -75.5757236,
          lat: 6.3444737
        },
        {
          lng: -75.5769253,
          lat: 6.3436206
        },
        {
          lng: -75.5777836,
          lat: 6.341488
        },
        {
          lng: -75.5773544,
          lat: 6.3393554
        },
        {
          lng: -75.5718613,
          lat: 6.3391847
        },
        {
          lng: -75.5711746,
          lat: 6.3379905
        },
        {
          lng: -75.5722046,
          lat: 6.3368815
        },
        {
          lng: -75.5740929,
          lat: 6.3364549
        },
        {
          lng: -75.5764103,
          lat: 6.3358578
        },
        {
          lng: -75.5746937,
          lat: 6.3344076
        },
        {
          lng: -75.5726337,
          lat: 6.3334692
        },
        {
          lng: -75.5687714,
          lat: 6.3319337
        },
        {
          lng: -75.5667114,
          lat: 6.3317631
        },
        {
          lng: -75.5659389,
          lat: 6.3305688
        },
        {
          lng: -75.5655098,
          lat: 6.3286067
        },
        {
          lng: -75.5661964,
          lat: 6.3280095
        },
        {
          lng: -75.5683422,
          lat: 6.3269005
        },
        {
          lng: -75.5700588,
          lat: 6.3263034
        },
        {
          lng: -75.5704021,
          lat: 6.3246825
        },
        {
          lng: -75.5697155,
          lat: 6.3229764
        },
        {
          lng: -75.5691147,
          lat: 6.3216967
        },
        {
          lng: -75.5685139,
          lat: 6.3205024
        },
        {
          lng: -75.5673981,
          lat: 6.3210143
        },
        {
          lng: -75.5661964,
          lat: 6.3205877
        },
        {
          lng: -75.5673981,
          lat: 6.3191375
        },
        {
          lng: -75.5681705,
          lat: 6.3162369
        },
        {
          lng: -75.5702305,
          lat: 6.3160663
        },
        {
          lng: -75.5705738,
          lat: 6.3147014
        },
        {
          lng: -75.5728912,
          lat: 6.3142748
        },
        {
          lng: -75.5746078,
          lat: 6.3147867
        },
        {
          lng: -75.5776119,
          lat: 6.3153838
        },
        {
          lng: -75.5805302,
          lat: 6.3163223
        },
        {
          lng: -75.5849934,
          lat: 6.317346
        },
        {
          lng: -75.5867958,
          lat: 6.3169194
        },
        {
          lng: -75.5886841,
          lat: 6.3154692
        },
        {
          lng: -75.5891991,
          lat: 6.3143601
        },
        {
          lng: -75.5879116,
          lat: 6.3128245
        },
        {
          lng: -75.58671,
          lat: 6.3117155
        },
        {
          lng: -75.5873108,
          lat: 6.3104359
        },
        {
          lng: -75.5862808,
          lat: 6.3094974
        },
        {
          lng: -75.5859375,
          lat: 6.3070234
        },
        {
          lng: -75.5849075,
          lat: 6.3052319
        },
        {
          lng: -75.5837059,
          lat: 6.3041228
        },
        {
          lng: -75.5845642,
          lat: 6.3026725
        },
        {
          lng: -75.5869675,
          lat: 6.3025872
        },
        {
          lng: -75.5885124,
          lat: 6.3029285
        },
        {
          lng: -75.5890274,
          lat: 6.3015635
        },
        {
          lng: -75.5877399,
          lat: 6.3000279
        },
        {
          lng: -75.5866241,
          lat: 6.2980657
        },
        {
          lng: -75.5863667,
          lat: 6.2964447
        },
        {
          lng: -75.5876541,
          lat: 6.2949091
        },
        {
          lng: -75.5885983,
          lat: 6.2941413
        },
        {
          lng: -75.5896282,
          lat: 6.2952503
        },
        {
          lng: -75.5909157,
          lat: 6.2961888
        },
        {
          lng: -75.5923748,
          lat: 6.2961888
        },
        {
          lng: -75.5941772,
          lat: 6.2967007
        },
        {
          lng: -75.5950356,
          lat: 6.2972125
        },
        {
          lng: -75.5964088,
          lat: 6.2967007
        },
        {
          lng: -75.5977821,
          lat: 6.2957622
        },
        {
          lng: -75.5975246,
          lat: 6.2949944
        },
        {
          lng: -75.596838,
          lat: 6.2933734
        },
        {
          lng: -75.5969238,
          lat: 6.2918378
        },
        {
          lng: -75.5990696,
          lat: 6.2906434
        },
        {
          lng: -75.6000996,
          lat: 6.289449
        },
        {
          lng: -75.6013012,
          lat: 6.2883399
        },
        {
          lng: -75.6031895,
          lat: 6.2882546
        },
        {
          lng: -75.6043053,
          lat: 6.2892784
        },
        {
          lng: -75.6053352,
          lat: 6.2914965
        },
        {
          lng: -75.6062794,
          lat: 6.29107
        },
        {
          lng: -75.6078243,
          lat: 6.2900462
        },
        {
          lng: -75.6082535,
          lat: 6.2909847
        },
        {
          lng: -75.6088543,
          lat: 6.2920084
        },
        {
          lng: -75.6091976,
          lat: 6.2936294
        },
        {
          lng: -75.6098843,
          lat: 6.2956769
        },
        {
          lng: -75.6119442,
          lat: 6.2948238
        },
        {
          lng: -75.6123734,
          lat: 6.2932881
        },
        {
          lng: -75.6155491,
          lat: 6.2906434
        },
        {
          lng: -75.6154633,
          lat: 6.2898756
        },
        {
          lng: -75.6151199,
          lat: 6.2888518
        },
        {
          lng: -75.6150341,
          lat: 6.2876574
        },
        {
          lng: -75.613575,
          lat: 6.2862924
        },
        {
          lng: -75.6124592,
          lat: 6.2870602
        },
        {
          lng: -75.6108284,
          lat: 6.2876574
        },
        {
          lng: -75.6103134,
          lat: 6.2868043
        },
        {
          lng: -75.6102276,
          lat: 6.2854392
        },
        {
          lng: -75.6097984,
          lat: 6.2841595
        },
        {
          lng: -75.6091976,
          lat: 6.2828798
        },
        {
          lng: -75.6102276,
          lat: 6.2827945
        },
        {
          lng: -75.6121159,
          lat: 6.2827092
        },
        {
          lng: -75.6134033,
          lat: 6.2831357
        },
        {
          lng: -75.61409,
          lat: 6.2845008
        },
        {
          lng: -75.6150341,
          lat: 6.2844155
        },
        {
          lng: -75.6152058,
          lat: 6.2827945
        },
        {
          lng: -75.6164932,
          lat: 6.2826238
        },
        {
          lng: -75.6175232,
          lat: 6.2835623
        },
        {
          lng: -75.6189823,
          lat: 6.2835623
        },
        {
          lng: -75.6213856,
          lat: 6.2839889
        },
        {
          lng: -75.6224155,
          lat: 6.2836476
        },
        {
          lng: -75.624733,
          lat: 6.2828798
        },
        {
          lng: -75.6269646,
          lat: 6.2824532
        },
        {
          lng: -75.6291103,
          lat: 6.2819413
        },
        {
          lng: -75.630827,
          lat: 6.282112
        },
        {
          lng: -75.630827,
          lat: 6.2831357
        },
        {
          lng: -75.6302261,
          lat: 6.2847567
        },
        {
          lng: -75.6307411,
          lat: 6.2858658
        },
        {
          lng: -75.633316,
          lat: 6.2844155
        },
        {
          lng: -75.6347752,
          lat: 6.2829651
        },
        {
          lng: -75.6367493,
          lat: 6.2820266
        },
        {
          lng: -75.6375217,
          lat: 6.2827945
        },
        {
          lng: -75.63941,
          lat: 6.2833064
        },
        {
          lng: -75.6408691,
          lat: 6.2827092
        },
        {
          lng: -75.6419849,
          lat: 6.2819413
        },
        {
          lng: -75.643959,
          lat: 6.2822826
        },
        {
          lng: -75.6448174,
          lat: 6.2810882
        },
        {
          lng: -75.6432724,
          lat: 6.2792112
        },
        {
          lng: -75.6415558,
          lat: 6.2773343
        },
        {
          lng: -75.6402683,
          lat: 6.2762252
        },
        {
          lng: -75.6388092,
          lat: 6.2752014
        },
        {
          lng: -75.6370926,
          lat: 6.2744335
        },
        {
          lng: -75.6363201,
          lat: 6.2729831
        },
        {
          lng: -75.633831,
          lat: 6.2726419
        },
        {
          lng: -75.6321144,
          lat: 6.2719593
        },
        {
          lng: -75.6312561,
          lat: 6.2706796
        },
        {
          lng: -75.6299686,
          lat: 6.268376
        },
        {
          lng: -75.6275654,
          lat: 6.2675228
        },
        {
          lng: -75.6267929,
          lat: 6.2681201
        },
        {
          lng: -75.6266212,
          lat: 6.2711062
        },
        {
          lng: -75.6279945,
          lat: 6.2723859
        },
        {
          lng: -75.6279945,
          lat: 6.2735804
        },
        {
          lng: -75.6261921,
          lat: 6.2748601
        },
        {
          lng: -75.6248188,
          lat: 6.2745188
        },
        {
          lng: -75.6224155,
          lat: 6.2750307
        },
        {
          lng: -75.6217289,
          lat: 6.2760545
        },
        {
          lng: -75.6203556,
          lat: 6.2757986
        },
        {
          lng: -75.6197548,
          lat: 6.2748601
        },
        {
          lng: -75.6195831,
          lat: 6.2732391
        },
        {
          lng: -75.617609,
          lat: 6.2724712
        },
        {
          lng: -75.618124,
          lat: 6.2713621
        },
        {
          lng: -75.6194115,
          lat: 6.2705943
        },
        {
          lng: -75.6188107,
          lat: 6.2692292
        },
        {
          lng: -75.619669,
          lat: 6.2677788
        },
        {
          lng: -75.6193256,
          lat: 6.2665843
        },
        {
          lng: -75.6178665,
          lat: 6.2654752
        },
        {
          lng: -75.6164074,
          lat: 6.2643661
        },
        {
          lng: -75.6163216,
          lat: 6.2632569
        },
        {
          lng: -75.6169224,
          lat: 6.2620625
        },
        {
          lng: -75.618124,
          lat: 6.2621478
        },
        {
          lng: -75.619669,
          lat: 6.2626597
        },
        {
          lng: -75.6211281,
          lat: 6.2624037
        },
        {
          lng: -75.6219864,
          lat: 6.2635129
        },
        {
          lng: -75.6231022,
          lat: 6.2636835
        },
        {
          lng: -75.6243038,
          lat: 6.2624891
        },
        {
          lng: -75.6238747,
          lat: 6.2606974
        },
        {
          lng: -75.6230164,
          lat: 6.2590763
        },
        {
          lng: -75.6233597,
          lat: 6.2575406
        },
        {
          lng: -75.6246471,
          lat: 6.2582231
        },
        {
          lng: -75.6263638,
          lat: 6.2600148
        },
        {
          lng: -75.6272221,
          lat: 6.2614652
        },
        {
          lng: -75.6286812,
          lat: 6.2630863
        },
        {
          lng: -75.628767,
          lat: 6.2612946
        },
        {
          lng: -75.629282,
          lat: 6.2601001
        },
        {
          lng: -75.6302261,
          lat: 6.2596735
        },
        {
          lng: -75.6319427,
          lat: 6.2594176
        },
        {
          lng: -75.6315136,
          lat: 6.2575406
        },
        {
          lng: -75.6293678,
          lat: 6.2566874
        },
        {
          lng: -75.6297112,
          lat: 6.2557489
        },
        {
          lng: -75.6312561,
          lat: 6.2557489
        },
        {
          lng: -75.6322861,
          lat: 6.2550663
        },
        {
          lng: -75.6322002,
          lat: 6.2537012
        },
        {
          lng: -75.6311703,
          lat: 6.2525067
        },
        {
          lng: -75.6294537,
          lat: 6.252592
        },
        {
          lng: -75.6289387,
          lat: 6.2513975
        },
        {
          lng: -75.6312561,
          lat: 6.250715
        },
        {
          lng: -75.6334877,
          lat: 6.2510563
        },
        {
          lng: -75.6355476,
          lat: 6.2512269
        },
        {
          lng: -75.6370068,
          lat: 6.2503737
        },
        {
          lng: -75.6372643,
          lat: 6.2487526
        },
        {
          lng: -75.6355476,
          lat: 6.2482407
        },
        {
          lng: -75.635376,
          lat: 6.2473022
        },
        {
          lng: -75.6364059,
          lat: 6.2464489
        },
        {
          lng: -75.6352901,
          lat: 6.2449985
        },
        {
          lng: -75.6337452,
          lat: 6.245681
        },
        {
          lng: -75.6315136,
          lat: 6.2466196
        },
        {
          lng: -75.6300545,
          lat: 6.2465343
        },
        {
          lng: -75.628252,
          lat: 6.2449132
        },
        {
          lng: -75.6261921,
          lat: 6.2454251
        },
        {
          lng: -75.6244755,
          lat: 6.2445719
        },
        {
          lng: -75.6229305,
          lat: 6.2432067
        },
        {
          lng: -75.6219006,
          lat: 6.2415003
        },
        {
          lng: -75.6208706,
          lat: 6.2427801
        },
        {
          lng: -75.6190681,
          lat: 6.2430361
        },
        {
          lng: -75.6182098,
          lat: 6.2420122
        },
        {
          lng: -75.6166649,
          lat: 6.2426095
        },
        {
          lng: -75.6164074,
          lat: 6.2417563
        },
        {
          lng: -75.6160641,
          lat: 6.239026
        },
        {
          lng: -75.6137466,
          lat: 6.2386847
        },
        {
          lng: -75.61203,
          lat: 6.2369782
        },
        {
          lng: -75.6119442,
          lat: 6.2354424
        },
        {
          lng: -75.6129742,
          lat: 6.2357837
        },
        {
          lng: -75.6164074,
          lat: 6.2368929
        },
        {
          lng: -75.6194115,
          lat: 6.2372342
        },
        {
          lng: -75.6227589,
          lat: 6.2366369
        },
        {
          lng: -75.6250763,
          lat: 6.235613
        },
        {
          lng: -75.6279945,
          lat: 6.2345892
        },
        {
          lng: -75.6302261,
          lat: 6.2343332
        },
        {
          lng: -75.6329727,
          lat: 6.2353571
        },
        {
          lng: -75.6347752,
          lat: 6.2349305
        },
        {
          lng: -75.6337452,
          lat: 6.2343332
        },
        {
          lng: -75.6342602,
          lat: 6.233224
        },
        {
          lng: -75.6365776,
          lat: 6.23348
        },
        {
          lng: -75.6382942,
          lat: 6.2328827
        },
        {
          lng: -75.6370068,
          lat: 6.2319441
        },
        {
          lng: -75.6340027,
          lat: 6.2321148
        },
        {
          lng: -75.6310844,
          lat: 6.2322001
        },
        {
          lng: -75.6300545,
          lat: 6.2319441
        },
        {
          lng: -75.6275654,
          lat: 6.2314322
        },
        {
          lng: -75.6261921,
          lat: 6.2317735
        },
        {
          lng: -75.6239605,
          lat: 6.2321148
        },
        {
          lng: -75.6229305,
          lat: 6.2333093
        },
        {
          lng: -75.6208706,
          lat: 6.2350158
        },
        {
          lng: -75.6177807,
          lat: 6.2348451
        },
        {
          lng: -75.6174374,
          lat: 6.2337359
        },
        {
          lng: -75.6168365,
          lat: 6.2320295
        },
        {
          lng: -75.6159782,
          lat: 6.2304083
        },
        {
          lng: -75.6152916,
          lat: 6.2289578
        },
        {
          lng: -75.6145191,
          lat: 6.2275926
        },
        {
          lng: -75.6131458,
          lat: 6.2265687
        },
        {
          lng: -75.6123734,
          lat: 6.2246916
        },
        {
          lng: -75.6128025,
          lat: 6.2229851
        },
        {
          lng: -75.6148624,
          lat: 6.2226438
        },
        {
          lng: -75.6170082,
          lat: 6.2228998
        },
        {
          lng: -75.6198406,
          lat: 6.2234117
        },
        {
          lng: -75.6223297,
          lat: 6.223753
        },
        {
          lng: -75.624733,
          lat: 6.2246063
        },
        {
          lng: -75.6260204,
          lat: 6.2253742
        },
        {
          lng: -75.6274796,
          lat: 6.2250329
        },
        {
          lng: -75.629282,
          lat: 6.2243503
        },
        {
          lng: -75.6320286,
          lat: 6.2241797
        },
        {
          lng: -75.6329727,
          lat: 6.2244356
        },
        {
          lng: -75.634346,
          lat: 6.2244356
        },
        {
          lng: -75.6344318,
          lat: 6.2232411
        },
        {
          lng: -75.6360626,
          lat: 6.2226438
        },
        {
          lng: -75.6369209,
          lat: 6.2231558
        },
        {
          lng: -75.6383801,
          lat: 6.2225585
        },
        {
          lng: -75.6392384,
          lat: 6.2218759
        },
        {
          lng: -75.6405258,
          lat: 6.2223878
        },
        {
          lng: -75.6408691,
          lat: 6.221108
        },
        {
          lng: -75.6401825,
          lat: 6.2195721
        },
        {
          lng: -75.6386375,
          lat: 6.2199987
        },
        {
          lng: -75.6372643,
          lat: 6.22034
        },
        {
          lng: -75.6378651,
          lat: 6.2190601
        },
        {
          lng: -75.6372643,
          lat: 6.2176096
        },
        {
          lng: -75.6354618,
          lat: 6.2176949
        },
        {
          lng: -75.633831,
          lat: 6.2187188
        },
        {
          lng: -75.6335735,
          lat: 6.2201694
        },
        {
          lng: -75.6325436,
          lat: 6.2209373
        },
        {
          lng: -75.6310844,
          lat: 6.2217052
        },
        {
          lng: -75.6293678,
          lat: 6.2215346
        },
        {
          lng: -75.627737,
          lat: 6.2210226
        },
        {
          lng: -75.6259346,
          lat: 6.2213639
        },
        {
          lng: -75.6241322,
          lat: 6.2223878
        },
        {
          lng: -75.6230164,
          lat: 6.2209373
        },
        {
          lng: -75.6220722,
          lat: 6.2211933
        },
        {
          lng: -75.6219864,
          lat: 6.2221319
        },
        {
          lng: -75.6198406,
          lat: 6.2219612
        },
        {
          lng: -75.6200123,
          lat: 6.22034
        },
        {
          lng: -75.6176949,
          lat: 6.2197427
        },
        {
          lng: -75.6160641,
          lat: 6.2199987
        },
        {
          lng: -75.6134892,
          lat: 6.2195721
        },
        {
          lng: -75.6109142,
          lat: 6.2190601
        },
        {
          lng: -75.6096268,
          lat: 6.2186335
        },
        {
          lng: -75.6091118,
          lat: 6.216671
        },
        {
          lng: -75.6077385,
          lat: 6.2159031
        },
        {
          lng: -75.6061935,
          lat: 6.2161591
        },
        {
          lng: -75.6047344,
          lat: 6.2155618
        },
        {
          lng: -75.6052494,
          lat: 6.2141112
        },
        {
          lng: -75.6059361,
          lat: 6.2131726
        },
        {
          lng: -75.6067085,
          lat: 6.2123194
        },
        {
          lng: -75.6068802,
          lat: 6.2110395
        },
        {
          lng: -75.6057644,
          lat: 6.2101009
        },
        {
          lng: -75.6067944,
          lat: 6.209077
        },
        {
          lng: -75.6086826,
          lat: 6.2095036
        },
        {
          lng: -75.6102276,
          lat: 6.2100156
        },
        {
          lng: -75.6095409,
          lat: 6.2082237
        },
        {
          lng: -75.6073093,
          lat: 6.2074557
        },
        {
          lng: -75.6061935,
          lat: 6.2064318
        },
        {
          lng: -75.6083393,
          lat: 6.2063465
        },
        {
          lng: -75.6095409,
          lat: 6.2052372
        },
        {
          lng: -75.6073093,
          lat: 6.2044693
        },
        {
          lng: -75.6060219,
          lat: 6.202848
        },
        {
          lng: -75.6036186,
          lat: 6.2022507
        },
        {
          lng: -75.6031895,
          lat: 6.2011415
        },
        {
          lng: -75.6018162,
          lat: 6.1996056
        },
        {
          lng: -75.6017303,
          lat: 6.2002882
        },
        {
          lng: -75.6006145,
          lat: 6.2005442
        },
        {
          lng: -75.5997562,
          lat: 6.2016534
        },
        {
          lng: -75.5983829,
          lat: 6.2030187
        },
        {
          lng: -75.597353,
          lat: 6.2026774
        },
        {
          lng: -75.5956364,
          lat: 6.2015681
        },
        {
          lng: -75.5950356,
          lat: 6.2004588
        },
        {
          lng: -75.5961514,
          lat: 6.1996909
        },
        {
          lng: -75.5967522,
          lat: 6.1982403
        },
        {
          lng: -75.597353,
          lat: 6.1967044
        },
        {
          lng: -75.597868,
          lat: 6.1954244
        },
        {
          lng: -75.5994129,
          lat: 6.1950831
        },
        {
          lng: -75.600872,
          lat: 6.1949125
        },
        {
          lng: -75.6025887,
          lat: 6.1945711
        },
        {
          lng: -75.6042194,
          lat: 6.1939738
        },
        {
          lng: -75.6055927,
          lat: 6.1940592
        },
        {
          lng: -75.606966,
          lat: 6.1949125
        },
        {
          lng: -75.6084251,
          lat: 6.1949125
        },
        {
          lng: -75.6086826,
          lat: 6.1935472
        },
        {
          lng: -75.609026,
          lat: 6.1922672
        },
        {
          lng: -75.6101418,
          lat: 6.1914139
        },
        {
          lng: -75.6121159,
          lat: 6.1909873
        },
        {
          lng: -75.6141758,
          lat: 6.1913286
        },
        {
          lng: -75.6163216,
          lat: 6.1922672
        },
        {
          lng: -75.6174374,
          lat: 6.1933765
        },
        {
          lng: -75.6182957,
          lat: 6.1918406
        },
        {
          lng: -75.6176949,
          lat: 6.1902193
        },
        {
          lng: -75.6179523,
          lat: 6.1890247
        },
        {
          lng: -75.6175232,
          lat: 6.1873181
        },
        {
          lng: -75.6153774,
          lat: 6.1864648
        },
        {
          lng: -75.6128883,
          lat: 6.1830515
        },
        {
          lng: -75.6134892,
          lat: 6.1805769
        },
        {
          lng: -75.613575,
          lat: 6.1778463
        },
        {
          lng: -75.6153774,
          lat: 6.1747743
        },
        {
          lng: -75.6187253,
          lat: 6.1736647
        },
        {
          lng: -75.6213856,
          lat: 6.1729823
        },
        {
          lng: -75.6236172,
          lat: 6.1727263
        },
        {
          lng: -75.6262779,
          lat: 6.1735797
        },
        {
          lng: -75.6302261,
          lat: 6.1753716
        },
        {
          lng: -75.6345177,
          lat: 6.1760543
        },
        {
          lng: -75.6351185,
          lat: 6.1774196
        },
        {
          lng: -75.6361485,
          lat: 6.1783583
        },
        {
          lng: -75.6370068,
          lat: 6.1799796
        },
        {
          lng: -75.6376934,
          lat: 6.1820275
        },
        {
          lng: -75.6390667,
          lat: 6.1835635
        },
        {
          lng: -75.6392384,
          lat: 6.1848435
        },
        {
          lng: -75.639925,
          lat: 6.1865501
        },
        {
          lng: -75.6413841,
          lat: 6.1866354
        },
        {
          lng: -75.643959,
          lat: 6.1881714
        },
        {
          lng: -75.6441307,
          lat: 6.18911
        },
        {
          lng: -75.6453323,
          lat: 6.1900487
        },
        {
          lng: -75.6469631,
          lat: 6.1894513
        },
        {
          lng: -75.6486797,
          lat: 6.1894513
        },
        {
          lng: -75.6501389,
          lat: 6.190134
        },
        {
          lng: -75.6519413,
          lat: 6.190646
        },
        {
          lng: -75.6535721,
          lat: 6.1909873
        },
        {
          lng: -75.6546021,
          lat: 6.1914993
        },
        {
          lng: -75.6564903,
          lat: 6.1912433
        },
        {
          lng: -75.6559753,
          lat: 6.1889394
        },
        {
          lng: -75.6565762,
          lat: 6.1877447
        },
        {
          lng: -75.6580353,
          lat: 6.1879154
        },
        {
          lng: -75.6591511,
          lat: 6.1887687
        },
        {
          lng: -75.6618977,
          lat: 6.1887687
        },
        {
          lng: -75.6629276,
          lat: 6.1877447
        },
        {
          lng: -75.6619835,
          lat: 6.1861234
        },
        {
          lng: -75.6625843,
          lat: 6.1853555
        },
        {
          lng: -75.6626701,
          lat: 6.1839902
        },
        {
          lng: -75.662756,
          lat: 6.1828809
        },
        {
          lng: -75.6618118,
          lat: 6.1804062
        },
        {
          lng: -75.6593227,
          lat: 6.1796383
        },
        {
          lng: -75.661726,
          lat: 6.174689
        },
        {
          lng: -75.6599236,
          lat: 6.1738357
        },
        {
          lng: -75.6576061,
          lat: 6.172897
        },
        {
          lng: -75.6540871,
          lat: 6.172641
        },
        {
          lng: -75.651083,
          lat: 6.173665
        },
        {
          lng: -75.6488514,
          lat: 6.1727263
        },
        {
          lng: -75.6474781,
          lat: 6.1717023
        },
        {
          lng: -75.645504,
          lat: 6.1714463
        },
        {
          lng: -75.6443024,
          lat: 6.170849
        },
        {
          lng: -75.6456757,
          lat: 6.1699957
        },
        {
          lng: -75.6454182,
          lat: 6.169057
        },
        {
          lng: -75.6445599,
          lat: 6.1679476
        },
        {
          lng: -75.6443024,
          lat: 6.1663263
        },
        {
          lng: -75.6446457,
          lat: 6.1650463
        },
        {
          lng: -75.6457615,
          lat: 6.1663263
        },
        {
          lng: -75.6464481,
          lat: 6.167521
        },
        {
          lng: -75.6486797,
          lat: 6.1682037
        },
        {
          lng: -75.6497955,
          lat: 6.1665823
        },
        {
          lng: -75.6491089,
          lat: 6.1645343
        },
        {
          lng: -75.6491089,
          lat: 6.1625716
        },
        {
          lng: -75.6488514,
          lat: 6.1602675
        },
        {
          lng: -75.6493664,
          lat: 6.1578782
        },
        {
          lng: -75.6498814,
          lat: 6.1555741
        },
        {
          lng: -75.6513405,
          lat: 6.1540381
        },
        {
          lng: -75.6533146,
          lat: 6.1529287
        },
        {
          lng: -75.6552029,
          lat: 6.152758
        },
        {
          lng: -75.656662,
          lat: 6.1524167
        },
        {
          lng: -75.6570911,
          lat: 6.1508806
        },
        {
          lng: -75.6558895,
          lat: 6.1500272
        },
        {
          lng: -75.6532287,
          lat: 6.151478
        },
        {
          lng: -75.6504822,
          lat: 6.1519046
        },
        {
          lng: -75.6473064,
          lat: 6.1519046
        },
        {
          lng: -75.6454182,
          lat: 6.1505393
        },
        {
          lng: -75.6430149,
          lat: 6.1499419
        },
        {
          lng: -75.6418133,
          lat: 6.1490032
        },
        {
          lng: -75.6408691,
          lat: 6.1496859
        },
        {
          lng: -75.6387234,
          lat: 6.1492592
        },
        {
          lng: -75.6381225,
          lat: 6.1480645
        },
        {
          lng: -75.6360626,
          lat: 6.1474671
        },
        {
          lng: -75.6365776,
          lat: 6.1463578
        },
        {
          lng: -75.6377792,
          lat: 6.1450777
        },
        {
          lng: -75.638895,
          lat: 6.1435416
        },
        {
          lng: -75.6385517,
          lat: 6.1419202
        },
        {
          lng: -75.6372642,
          lat: 6.1410668
        },
        {
          lng: -75.6362343,
          lat: 6.1392747
        },
        {
          lng: -75.6371784,
          lat: 6.1387627
        },
        {
          lng: -75.6388092,
          lat: 6.1392747
        },
        {
          lng: -75.6401825,
          lat: 6.1389334
        },
        {
          lng: -75.6403541,
          lat: 6.1375679
        },
        {
          lng: -75.6398392,
          lat: 6.1359465
        },
        {
          lng: -75.6388092,
          lat: 6.1343251
        },
        {
          lng: -75.6371784,
          lat: 6.1331303
        },
        {
          lng: -75.6370926,
          lat: 6.1304848
        },
        {
          lng: -75.6364918,
          lat: 6.1281806
        },
        {
          lng: -75.6371784,
          lat: 6.1263031
        },
        {
          lng: -75.6363201,
          lat: 6.1248523
        },
        {
          lng: -75.6363201,
          lat: 6.1233162
        },
        {
          lng: -75.6354618,
          lat: 6.1224628
        },
        {
          lng: -75.6352043,
          lat: 6.1199879
        },
        {
          lng: -75.6362343,
          lat: 6.1189638
        },
        {
          lng: -75.6375217,
          lat: 6.1189638
        },
        {
          lng: -75.6388092,
          lat: 6.1200732
        },
        {
          lng: -75.6397533,
          lat: 6.1210973
        },
        {
          lng: -75.6407833,
          lat: 6.1203292
        },
        {
          lng: -75.6398392,
          lat: 6.1192198
        },
        {
          lng: -75.6389809,
          lat: 6.1184517
        },
        {
          lng: -75.6373501,
          lat: 6.1162329
        },
        {
          lng: -75.6380367,
          lat: 6.1155501
        },
        {
          lng: -75.6378651,
          lat: 6.1144407
        },
        {
          lng: -75.6371784,
          lat: 6.1129045
        },
        {
          lng: -75.6381225,
          lat: 6.1127338
        },
        {
          lng: -75.6392383,
          lat: 6.1132459
        },
        {
          lng: -75.6402683,
          lat: 6.1128192
        },
        {
          lng: -75.6413841,
          lat: 6.1128192
        },
        {
          lng: -75.6418991,
          lat: 6.111795
        },
        {
          lng: -75.6433582,
          lat: 6.1118804
        },
        {
          lng: -75.6432724,
          lat: 6.1106002
        },
        {
          lng: -75.6427574,
          lat: 6.108808
        },
        {
          lng: -75.6425857,
          lat: 6.1059917
        },
        {
          lng: -75.6432724,
          lat: 6.1047969
        },
        {
          lng: -75.6451607,
          lat: 6.1047969
        },
        {
          lng: -75.6454182,
          lat: 6.1036874
        },
        {
          lng: -75.6442165,
          lat: 6.1031753
        },
        {
          lng: -75.6431866,
          lat: 6.1018952
        },
        {
          lng: -75.6434441,
          lat: 6.1001883
        },
        {
          lng: -75.6443882,
          lat: 6.0989081
        },
        {
          lng: -75.6452465,
          lat: 6.0977133
        },
        {
          lng: -75.6451607,
          lat: 6.0967745
        },
        {
          lng: -75.644989,
          lat: 6.0952383
        },
        {
          lng: -75.6462765,
          lat: 6.0933607
        },
        {
          lng: -75.6468773,
          lat: 6.0916537
        },
        {
          lng: -75.6468773,
          lat: 6.0893494
        },
        {
          lng: -75.6453323,
          lat: 6.0875571
        },
        {
          lng: -75.644474,
          lat: 6.0861916
        },
        {
          lng: -75.6425857,
          lat: 6.0857648
        },
        {
          lng: -75.6426716,
          lat: 6.0834605
        },
        {
          lng: -75.6435299,
          lat: 6.0805586
        },
        {
          lng: -75.6430149,
          lat: 6.0787663
        },
        {
          lng: -75.6416416,
          lat: 6.0775715
        },
        {
          lng: -75.6389809,
          lat: 6.0784249
        },
        {
          lng: -75.6365776,
          lat: 6.0797905
        },
        {
          lng: -75.6347752,
          lat: 6.0802172
        },
        {
          lng: -75.6346893,
          lat: 6.0790224
        },
        {
          lng: -75.634861,
          lat: 6.0765473
        },
        {
          lng: -75.6337452,
          lat: 6.0751817
        },
        {
          lng: -75.6314278,
          lat: 6.0755231
        },
        {
          lng: -75.6297111,
          lat: 6.0776568
        },
        {
          lng: -75.6290245,
          lat: 6.0799612
        },
        {
          lng: -75.6295395,
          lat: 6.0818389
        },
        {
          lng: -75.629797,
          lat: 6.0831191
        },
        {
          lng: -75.629282,
          lat: 6.0841432
        },
        {
          lng: -75.6294536,
          lat: 6.0857648
        },
        {
          lng: -75.627737,
          lat: 6.0851674
        },
        {
          lng: -75.6254196,
          lat: 6.0851674
        },
        {
          lng: -75.623703,
          lat: 6.0841432
        },
        {
          lng: -75.6240463,
          lat: 6.0856795
        },
        {
          lng: -75.6234455,
          lat: 6.0867036
        },
        {
          lng: -75.6212997,
          lat: 6.0865329
        },
        {
          lng: -75.6212139,
          lat: 6.0874718
        },
        {
          lng: -75.6241321,
          lat: 6.0886666
        },
        {
          lng: -75.6252479,
          lat: 6.0903735
        },
        {
          lng: -75.6264496,
          lat: 6.0925925
        },
        {
          lng: -75.6261063,
          lat: 6.0937874
        },
        {
          lng: -75.6249046,
          lat: 6.0949822
        },
        {
          lng: -75.6238747,
          lat: 6.0961771
        },
        {
          lng: -75.6215572,
          lat: 6.0963477
        },
        {
          lng: -75.6219005,
          lat: 6.0977986
        },
        {
          lng: -75.6210422,
          lat: 6.098396
        },
        {
          lng: -75.6213856,
          lat: 6.0996762
        },
        {
          lng: -75.619154,
          lat: 6.1007003
        },
        {
          lng: -75.6190681,
          lat: 6.1019805
        },
        {
          lng: -75.6204414,
          lat: 6.1020659
        },
        {
          lng: -75.6222439,
          lat: 6.1024926
        },
        {
          lng: -75.6243038,
          lat: 6.1005297
        },
        {
          lng: -75.6267929,
          lat: 6.0990788
        },
        {
          lng: -75.6300545,
          lat: 6.0971159
        },
        {
          lng: -75.6328869,
          lat: 6.0960917
        },
        {
          lng: -75.6350326,
          lat: 6.0955796
        },
        {
          lng: -75.6352043,
          lat: 6.0977986
        },
        {
          lng: -75.6354618,
          lat: 6.0995909
        },
        {
          lng: -75.635891,
          lat: 6.1024072
        },
        {
          lng: -75.6356335,
          lat: 6.1052236
        },
        {
          lng: -75.6351185,
          lat: 6.1071865
        },
        {
          lng: -75.6347752,
          lat: 6.1110269
        },
        {
          lng: -75.6340027,
          lat: 6.1137579
        },
        {
          lng: -75.6321144,
          lat: 6.11427
        },
        {
          lng: -75.6299686,
          lat: 6.1146113
        },
        {
          lng: -75.630312,
          lat: 6.1162328
        },
        {
          lng: -75.6307411,
          lat: 6.1181957
        },
        {
          lng: -75.6309128,
          lat: 6.1193905
        },
        {
          lng: -75.6300545,
          lat: 6.1222067
        },
        {
          lng: -75.6302261,
          lat: 6.1257057
        },
        {
          lng: -75.6311703,
          lat: 6.1280099
        },
        {
          lng: -75.6315994,
          lat: 6.1303994
        },
        {
          lng: -75.6316852,
          lat: 6.1322769
        },
        {
          lng: -75.6320286,
          lat: 6.1361172
        },
        {
          lng: -75.630312,
          lat: 6.1379946
        },
        {
          lng: -75.6291103,
          lat: 6.13936
        },
        {
          lng: -75.6300545,
          lat: 6.1407255
        },
        {
          lng: -75.632801,
          lat: 6.1414082
        },
        {
          lng: -75.6329727,
          lat: 6.1431149
        },
        {
          lng: -75.6330585,
          lat: 6.1456751
        },
        {
          lng: -75.633831,
          lat: 6.1474671
        },
        {
          lng: -75.6341743,
          lat: 6.1487472
        },
        {
          lng: -75.633831,
          lat: 6.1504539
        },
        {
          lng: -75.633316,
          lat: 6.1515633
        },
        {
          lng: -75.6322861,
          lat: 6.1501979
        },
        {
          lng: -75.6299686,
          lat: 6.1494299
        },
        {
          lng: -75.6279087,
          lat: 6.1484058
        },
        {
          lng: -75.6262779,
          lat: 6.1470404
        },
        {
          lng: -75.6255054,
          lat: 6.1455897
        },
        {
          lng: -75.6232738,
          lat: 6.1439683
        },
        {
          lng: -75.6204414,
          lat: 6.1421762
        },
        {
          lng: -75.6183815,
          lat: 6.1421762
        },
        {
          lng: -75.6171799,
          lat: 6.1408961
        },
        {
          lng: -75.6162357,
          lat: 6.1389334
        },
        {
          lng: -75.6159782,
          lat: 6.1398721
        },
        {
          lng: -75.6149483,
          lat: 6.1398721
        },
        {
          lng: -75.6142616,
          lat: 6.1384213
        },
        {
          lng: -75.6132317,
          lat: 6.1384213
        },
        {
          lng: -75.6134033,
          lat: 6.1410668
        },
        {
          lng: -75.6144333,
          lat: 6.1434563
        },
        {
          lng: -75.6151199,
          lat: 6.145163
        },
        {
          lng: -75.6150341,
          lat: 6.1471258
        },
        {
          lng: -75.6129742,
          lat: 6.1464431
        },
        {
          lng: -75.6109142,
          lat: 6.1465284
        },
        {
          lng: -75.6084251,
          lat: 6.1474671
        },
        {
          lng: -75.606966,
          lat: 6.1496006
        },
        {
          lng: -75.6061077,
          lat: 6.151222
        },
        {
          lng: -75.6052494,
          lat: 6.152758
        },
        {
          lng: -75.6062794,
          lat: 6.153526
        },
        {
          lng: -75.6079102,
          lat: 6.1543794
        },
        {
          lng: -75.6067085,
          lat: 6.1552328
        },
        {
          lng: -75.6051636,
          lat: 6.1558301
        },
        {
          lng: -75.6041336,
          lat: 6.1547207
        },
        {
          lng: -75.6036186,
          lat: 6.1536114
        },
        {
          lng: -75.6037903,
          lat: 6.1523313
        },
        {
          lng: -75.6022453,
          lat: 6.1508806
        },
        {
          lng: -75.6002712,
          lat: 6.1499419
        },
        {
          lng: -75.5979538,
          lat: 6.1484058
        },
        {
          lng: -75.595808,
          lat: 6.1484912
        },
        {
          lng: -75.595808,
          lat: 6.1501979
        },
        {
          lng: -75.5961514,
          lat: 6.1519046
        },
        {
          lng: -75.5952072,
          lat: 6.1523313
        },
        {
          lng: -75.5936623,
          lat: 6.1506246
        },
        {
          lng: -75.5916023,
          lat: 6.1500272
        },
        {
          lng: -75.5890274,
          lat: 6.1505393
        },
        {
          lng: -75.5881691,
          lat: 6.1513073
        },
        {
          lng: -75.5866241,
          lat: 6.1506246
        },
        {
          lng: -75.5855083,
          lat: 6.1495152
        },
        {
          lng: -75.586195,
          lat: 6.1484058
        },
        {
          lng: -75.5855942,
          lat: 6.1467844
        },
        {
          lng: -75.5842209,
          lat: 6.1463578
        },
        {
          lng: -75.5821609,
          lat: 6.1459311
        },
        {
          lng: -75.5802727,
          lat: 6.1462724
        },
        {
          lng: -75.5794144,
          lat: 6.1478938
        },
        {
          lng: -75.5779552,
          lat: 6.1473818
        },
        {
          lng: -75.5764961,
          lat: 6.1467844
        },
        {
          lng: -75.5749512,
          lat: 6.1467844
        },
        {
          lng: -75.5744362,
          lat: 6.1490032
        },
        {
          lng: -75.5746078,
          lat: 6.1504539
        },
        {
          lng: -75.5735779,
          lat: 6.1519046
        },
        {
          lng: -75.574522,
          lat: 6.1531847
        },
        {
          lng: -75.5746937,
          lat: 6.1542941
        },
        {
          lng: -75.5732346,
          lat: 6.1551474
        },
        {
          lng: -75.5735779,
          lat: 6.1564275
        },
        {
          lng: -75.5746078,
          lat: 6.1562568
        },
        {
          lng: -75.5740929,
          lat: 6.1582195
        },
        {
          lng: -75.5734062,
          lat: 6.1595849
        },
        {
          lng: -75.5717754,
          lat: 6.1599262
        },
        {
          lng: -75.569973,
          lat: 6.1611209
        },
        {
          lng: -75.5690289,
          lat: 6.1613769
        },
        {
          lng: -75.5680847,
          lat: 6.1606089
        },
        {
          lng: -75.5671406,
          lat: 6.1594995
        },
        {
          lng: -75.5659389,
          lat: 6.1589875
        },
        {
          lng: -75.564909,
          lat: 6.1607795
        },
        {
          lng: -75.5656815,
          lat: 6.1622302
        },
        {
          lng: -75.5656815,
          lat: 6.1639369
        },
        {
          lng: -75.5642223,
          lat: 6.1633396
        },
        {
          lng: -75.562849,
          lat: 6.1641076
        },
        {
          lng: -75.5630207,
          lat: 6.1650463
        },
        {
          lng: -75.5637073,
          lat: 6.167265
        },
        {
          lng: -75.5623341,
          lat: 6.1687156
        },
        {
          lng: -75.5619049,
          lat: 6.1704223
        },
        {
          lng: -75.5602741,
          lat: 6.1728116
        },
        {
          lng: -75.5584717,
          lat: 6.1743476
        },
        {
          lng: -75.5569267,
          lat: 6.1756276
        },
        {
          lng: -75.5554676,
          lat: 6.1777609
        },
        {
          lng: -75.553236,
          lat: 6.1805769
        },
        {
          lng: -75.5524635,
          lat: 6.1839902
        },
        {
          lng: -75.5525494,
          lat: 6.1871474
        },
        {
          lng: -75.5533218,
          lat: 6.1885127
        },
        {
          lng: -75.5540943,
          lat: 6.1917553
        },
        {
          lng: -75.5535793,
          lat: 6.1933765
        },
        {
          lng: -75.552721,
          lat: 6.1955098
        },
        {
          lng: -75.5513477,
          lat: 6.1989229
        },
        {
          lng: -75.5506611,
          lat: 6.2011415
        },
        {
          lng: -75.5505753,
          lat: 6.203104
        },
        {
          lng: -75.5480003,
          lat: 6.2043839
        },
        {
          lng: -75.5480862,
          lat: 6.2067731
        },
        {
          lng: -75.5479145,
          lat: 6.208565
        },
        {
          lng: -75.5473137,
          lat: 6.2097596
        },
        {
          lng: -75.5475712,
          lat: 6.2107835
        },
        {
          lng: -75.5474853,
          lat: 6.2122341
        },
        {
          lng: -75.5461979,
          lat: 6.2141966
        },
        {
          lng: -75.5451679,
          lat: 6.2153911
        },
        {
          lng: -75.5455112,
          lat: 6.217183
        },
        {
          lng: -75.5467129,
          lat: 6.2182922
        },
        {
          lng: -75.5484295,
          lat: 6.2199134
        },
        {
          lng: -75.5506611,
          lat: 6.2205107
        },
        {
          lng: -75.5528927,
          lat: 6.2200841
        },
        {
          lng: -75.5548668,
          lat: 6.2207667
        },
        {
          lng: -75.5565834,
          lat: 6.2211933
        },
        {
          lng: -75.5582142,
          lat: 6.2215346
        },
        {
          lng: -75.5597591,
          lat: 6.2228998
        },
        {
          lng: -75.5607891,
          lat: 6.2213639
        },
        {
          lng: -75.5625915,
          lat: 6.220596
        },
        {
          lng: -75.5636215,
          lat: 6.2199134
        },
        {
          lng: -75.564909,
          lat: 6.2191455
        },
        {
          lng: -75.5653381,
          lat: 6.22034
        },
        {
          lng: -75.5651987,
          lat: 6.2225052
        },
        {
          lng: -75.5651665,
          lat: 6.2247663
        },
        {
          lng: -75.5640507,
          lat: 6.2253742
        },
        {
          lng: -75.5623341,
          lat: 6.2253742
        },
        {
          lng: -75.5617332,
          lat: 6.2254595
        },
        {
          lng: -75.5604458,
          lat: 6.2246063
        },
        {
          lng: -75.5597591,
          lat: 6.2255448
        },
        {
          lng: -75.5583,
          lat: 6.2256302
        },
        {
          lng: -75.55727,
          lat: 6.2268247
        },
        {
          lng: -75.5583,
          lat: 6.2286165
        },
        {
          lng: -75.5584717,
          lat: 6.2310909
        },
        {
          lng: -75.55727,
          lat: 6.230579
        },
        {
          lng: -75.5559826,
          lat: 6.2294698
        },
        {
          lng: -75.5540085,
          lat: 6.2281046
        },
        {
          lng: -75.5518627,
          lat: 6.2275926
        },
        {
          lng: -75.5510044,
          lat: 6.2289578
        },
        {
          lng: -75.5503178,
          lat: 6.230067
        },
        {
          lng: -75.548687,
          lat: 6.2298964
        },
        {
          lng: -75.5495453,
          lat: 6.2283606
        },
        {
          lng: -75.5490303,
          lat: 6.2264834
        },
        {
          lng: -75.5477428,
          lat: 6.2263981
        },
        {
          lng: -75.5463695,
          lat: 6.2254595
        },
        {
          lng: -75.5437088,
          lat: 6.2252036
        },
        {
          lng: -75.5418205,
          lat: 6.2252889
        },
        {
          lng: -75.5404472,
          lat: 6.2275926
        },
        {
          lng: -75.5412197,
          lat: 6.2292138
        },
        {
          lng: -75.5403614,
          lat: 6.2316029
        },
        {
          lng: -75.5398464,
          lat: 6.2306643
        },
        {
          lng: -75.5395031,
          lat: 6.2288725
        },
        {
          lng: -75.5376148,
          lat: 6.2286165
        },
        {
          lng: -75.5369282,
          lat: 6.2279339
        },
        {
          lng: -75.537014,
          lat: 6.2263981
        },
        {
          lng: -75.535984,
          lat: 6.2239237
        },
        {
          lng: -75.5328083,
          lat: 6.2239237
        },
        {
          lng: -75.5333233,
          lat: 6.2250329
        },
        {
          lng: -75.5341816,
          lat: 6.22691
        },
        {
          lng: -75.5332375,
          lat: 6.2277633
        },
        {
          lng: -75.5318642,
          lat: 6.2269954
        },
        {
          lng: -75.5307484,
          lat: 6.2273367
        },
        {
          lng: -75.5293751,
          lat: 6.2272513
        },
        {
          lng: -75.5275726,
          lat: 6.227422
        },
        {
          lng: -75.5259418,
          lat: 6.2287018
        },
        {
          lng: -75.5261993,
          lat: 6.2299817
        },
        {
          lng: -75.5269718,
          lat: 6.2316882
        },
        {
          lng: -75.525856,
          lat: 6.2328827
        },
        {
          lng: -75.524826,
          lat: 6.2342479
        },
        {
          lng: -75.5249119,
          lat: 6.2360397
        },
        {
          lng: -75.526886,
          lat: 6.235869
        },
        {
          lng: -75.5267143,
          lat: 6.2369782
        },
        {
          lng: -75.526371,
          lat: 6.2383434
        },
        {
          lng: -75.526886,
          lat: 6.2389406
        },
        {
          lng: -75.5268002,
          lat: 6.2397939
        },
        {
          lng: -75.5275726,
          lat: 6.2395379
        },
        {
          lng: -75.5291176,
          lat: 6.2388553
        },
        {
          lng: -75.5306625,
          lat: 6.240903
        },
        {
          lng: -75.53092,
          lat: 6.2397085
        },
        {
          lng: -75.5321217,
          lat: 6.2391113
        },
        {
          lng: -75.5332375,
          lat: 6.2386847
        },
        {
          lng: -75.5342674,
          lat: 6.2376608
        },
        {
          lng: -75.5352974,
          lat: 6.2380021
        },
        {
          lng: -75.5364132,
          lat: 6.2381727
        },
        {
          lng: -75.5372715,
          lat: 6.2396232
        },
        {
          lng: -75.538044,
          lat: 6.241415
        },
        {
          lng: -75.5386448,
          lat: 6.2428654
        },
        {
          lng: -75.5397606,
          lat: 6.2446572
        },
        {
          lng: -75.5396748,
          lat: 6.2470462
        },
        {
          lng: -75.5386448,
          lat: 6.2473875
        },
        {
          lng: -75.5377006,
          lat: 6.2489232
        },
        {
          lng: -75.5374432,
          lat: 6.2514829
        },
        {
          lng: -75.537529,
          lat: 6.2541278
        },
        {
          lng: -75.5370998,
          lat: 6.2562608
        },
        {
          lng: -75.5377006,
          lat: 6.2576259
        },
        {
          lng: -75.5386448,
          lat: 6.2566874
        },
        {
          lng: -75.541563,
          lat: 6.2561755
        },
        {
          lng: -75.543623,
          lat: 6.2545544
        },
        {
          lng: -75.5462837,
          lat: 6.2529333
        },
        {
          lng: -75.5480003,
          lat: 6.2538718
        },
        {
          lng: -75.5479145,
          lat: 6.2556635
        },
        {
          lng: -75.5462837,
          lat: 6.2569433
        },
        {
          lng: -75.5445671,
          lat: 6.2577965
        },
        {
          lng: -75.5430222,
          lat: 6.2588204
        },
        {
          lng: -75.5429363,
          lat: 6.2606121
        },
        {
          lng: -75.5408764,
          lat: 6.261124
        },
        {
          lng: -75.5399322,
          lat: 6.2620625
        },
        {
          lng: -75.5393314,
          lat: 6.2638542
        },
        {
          lng: -75.538044,
          lat: 6.2635129
        },
        {
          lng: -75.5371857,
          lat: 6.2620625
        },
        {
          lng: -75.535469,
          lat: 6.2641101
        },
        {
          lng: -75.5331516,
          lat: 6.2660724
        },
        {
          lng: -75.5340958,
          lat: 6.2684613
        },
        {
          lng: -75.5355549,
          lat: 6.2710208
        },
        {
          lng: -75.5360699,
          lat: 6.273495
        },
        {
          lng: -75.5377865,
          lat: 6.273751
        },
        {
          lng: -75.537014,
          lat: 6.2744335
        },
        {
          lng: -75.5340099,
          lat: 6.2752014
        },
        {
          lng: -75.5349541,
          lat: 6.2759692
        },
        {
          lng: -75.5358124,
          lat: 6.2781021
        },
        {
          lng: -75.5371857,
          lat: 6.2798937
        },
        {
          lng: -75.5366707,
          lat: 6.2817707
        },
        {
          lng: -75.535984,
          lat: 6.2843301
        },
        {
          lng: -75.5350399,
          lat: 6.2860364
        },
        {
          lng: -75.5363274,
          lat: 6.2930322
        },
        {
          lng: -75.5370998,
          lat: 6.2943972
        },
        {
          lng: -75.5363274,
          lat: 6.2952503
        },
        {
          lng: -75.5361557,
          lat: 6.2968713
        },
        {
          lng: -75.5367565,
          lat: 6.2980657
        },
        {
          lng: -75.5383015,
          lat: 6.3001985
        },
        {
          lng: -75.5397606,
          lat: 6.3018194
        },
        {
          lng: -75.541048,
          lat: 6.3025872
        },
        {
          lng: -75.5426788,
          lat: 6.3037816
        },
        {
          lng: -75.5437088,
          lat: 6.3039522
        },
        {
          lng: -75.5455112,
          lat: 6.3049759
        },
        {
          lng: -75.5477428,
          lat: 6.3054878
        },
        {
          lng: -75.5491161,
          lat: 6.3063409
        },
        {
          lng: -75.5475712,
          lat: 6.3069381
        },
        {
          lng: -75.5460262,
          lat: 6.3067675
        },
        {
          lng: -75.5441379,
          lat: 6.3064262
        },
        {
          lng: -75.5437946,
          lat: 6.3080472
        },
        {
          lng: -75.5432796,
          lat: 6.3094974
        },
        {
          lng: -75.5443096,
          lat: 6.3111183
        },
        {
          lng: -75.5467987,
          lat: 6.312398
        },
        {
          lng: -75.5494595,
          lat: 6.3123127
        },
        {
          lng: -75.5492878,
          lat: 6.3135923
        },
        {
          lng: -75.5473137,
          lat: 6.3154692
        },
        {
          lng: -75.5469704,
          lat: 6.3183697
        },
        {
          lng: -75.5467129,
          lat: 6.3210143
        },
        {
          lng: -75.5468845,
          lat: 6.3226351
        },
        {
          lng: -75.5467129,
          lat: 6.3248532
        },
        {
          lng: -75.5455971,
          lat: 6.3263887
        },
        {
          lng: -75.5442238,
          lat: 6.326474
        },
        {
          lng: -75.5423355,
          lat: 6.3249385
        },
        {
          lng: -75.5404472,
          lat: 6.3255356
        },
        {
          lng: -75.5387306,
          lat: 6.3265593
        },
        {
          lng: -75.5390739,
          lat: 6.3277536
        },
        {
          lng: -75.5368423,
          lat: 6.3286067
        },
        {
          lng: -75.5347824,
          lat: 6.3282655
        },
        {
          lng: -75.5350399,
          lat: 6.3295451
        },
        {
          lng: -75.5334091,
          lat: 6.3303982
        },
        {
          lng: -75.5313492,
          lat: 6.3311659
        },
        {
          lng: -75.5298901,
          lat: 6.3311659
        },
        {
          lng: -75.5292034,
          lat: 6.332019
        },
        {
          lng: -75.5289459,
          lat: 6.3337251
        },
        {
          lng: -75.5265427,
          lat: 6.3348341
        },
        {
          lng: -75.5249977,
          lat: 6.3361137
        },
        {
          lng: -75.5225086,
          lat: 6.3367109
        },
        {
          lng: -75.5207062,
          lat: 6.3380758
        },
        {
          lng: -75.5190754,
          lat: 6.3377345
        },
        {
          lng: -75.5170155,
          lat: 6.3375639
        },
        {
          lng: -75.5140114,
          lat: 6.3385023
        },
        {
          lng: -75.5125523,
          lat: 6.3385023
        },
        {
          lng: -75.511179,
          lat: 6.3393554
        },
        {
          lng: -75.5098915,
          lat: 6.3402084
        },
        {
          lng: -75.5084324,
          lat: 6.339526
        },
        {
          lng: -75.5068016,
          lat: 6.3385876
        },
        {
          lng: -75.5053425,
          lat: 6.3389288
        },
        {
          lng: -75.5049133,
          lat: 6.3408055
        },
        {
          lng: -75.5043125,
          lat: 6.3420851
        },
        {
          lng: -75.5031967,
          lat: 6.3435353
        },
        {
          lng: -75.5019093,
          lat: 6.3454973
        },
        {
          lng: -75.500536,
          lat: 6.3469475
        },
        {
          lng: -75.4991627,
          lat: 6.3478006
        },
        {
          lng: -75.4971027,
          lat: 6.3483124
        },
        {
          lng: -75.4973602,
          lat: 6.3498479
        },
        {
          lng: -75.4965019,
          lat: 6.3507862
        },
        {
          lng: -75.4953861,
          lat: 6.350445
        },
        {
          lng: -75.4942703,
          lat: 6.3489948
        },
        {
          lng: -75.4928112,
          lat: 6.3494213
        },
        {
          lng: -75.4909229,
          lat: 6.3491654
        },
        {
          lng: -75.4903221,
          lat: 6.3507862
        },
        {
          lng: -75.4908371,
          lat: 6.3521511
        },
        {
          lng: -75.4904938,
          lat: 6.3540278
        },
        {
          lng: -75.4904938,
          lat: 6.3556485
        },
        {
          lng: -75.4895496,
          lat: 6.3565015
        },
        {
          lng: -75.4898071,
          lat: 6.358037
        },
        {
          lng: -75.4890347,
          lat: 6.3594871
        },
        {
          lng: -75.4879189,
          lat: 6.3612785
        },
        {
          lng: -75.4867172,
          lat: 6.3628992
        },
        {
          lng: -75.4877472,
          lat: 6.3634963
        },
        {
          lng: -75.4892063,
          lat: 6.3648612
        },
        {
          lng: -75.4886055,
          lat: 6.3659701
        },
        {
          lng: -75.4875755,
          lat: 6.3669084
        },
        {
          lng: -75.4880047,
          lat: 6.3697233
        },
        {
          lng: -75.4876614,
          lat: 6.3716853
        },
        {
          lng: -75.4866314,
          lat: 6.3728795
        },
        {
          lng: -75.484314,
          lat: 6.3743296
        },
        {
          lng: -75.4825115,
          lat: 6.3754385
        },
        {
          lng: -75.4805374,
          lat: 6.3765474
        },
        {
          lng: -75.4776192,
          lat: 6.3746708
        },
        {
          lng: -75.4759884,
          lat: 6.3753532
        },
        {
          lng: -75.4747868,
          lat: 6.3763768
        },
        {
          lng: -75.4764175,
          lat: 6.3772298
        },
        {
          lng: -75.4783058,
          lat: 6.3780828
        },
        {
          lng: -75.4803658,
          lat: 6.3789358
        },
        {
          lng: -75.4770184,
          lat: 6.3799593
        },
        {
          lng: -75.4710102,
          lat: 6.3814094
        },
        {
          lng: -75.4671478,
          lat: 6.3820918
        },
        {
          lng: -75.4631996,
          lat: 6.3829448
        },
        {
          lng: -75.4571915,
          lat: 6.3827742
        },
        {
          lng: -75.4565048,
          lat: 6.3799593
        },
        {
          lng: -75.4579639,
          lat: 6.3791916
        },
        {
          lng: -75.460453,
          lat: 6.3789358
        },
        {
          lng: -75.4635429,
          lat: 6.378424
        },
        {
          lng: -75.4634571,
          lat: 6.3768886
        },
        {
          lng: -75.4619122,
          lat: 6.3739031
        },
        {
          lng: -75.4596806,
          lat: 6.3692115
        },
        {
          lng: -75.4581356,
          lat: 6.3688703
        },
        {
          lng: -75.455904,
          lat: 6.3682732
        },
        {
          lng: -75.4533291,
          lat: 6.3682732
        },
        {
          lng: -75.4532433,
          lat: 6.3664819
        },
        {
          lng: -75.4524708,
          lat: 6.3644347
        },
        {
          lng: -75.450325,
          lat: 6.3655436
        },
        {
          lng: -75.4483509,
          lat: 6.3663113
        },
        {
          lng: -75.4463768,
          lat: 6.3652024
        },
        {
          lng: -75.4443169,
          lat: 6.3691262
        },
        {
          lng: -75.4427719,
          lat: 6.3711735
        },
        {
          lng: -75.4411411,
          lat: 6.374159
        },
        {
          lng: -75.4419136,
          lat: 6.3760356
        },
        {
          lng: -75.4415703,
          lat: 6.3782534
        },
        {
          lng: -75.439682,
          lat: 6.3780828
        },
        {
          lng: -75.4373646,
          lat: 6.3785946
        },
        {
          lng: -75.4359055,
          lat: 6.3803858
        },
        {
          lng: -75.4369354,
          lat: 6.380727
        },
        {
          lng: -75.4377079,
          lat: 6.3845655
        },
        {
          lng: -75.4370213,
          lat: 6.3914746
        },
        {
          lng: -75.4374504,
          lat: 6.3968483
        },
        {
          lng: -75.440712,
          lat: 6.3959953
        },
        {
          lng: -75.4436302,
          lat: 6.3942894
        },
        {
          lng: -75.4467201,
          lat: 6.3919864
        },
        {
          lng: -75.4495525,
          lat: 6.3895981
        },
        {
          lng: -75.4540157,
          lat: 6.3873803
        },
        {
          lng: -75.4590797,
          lat: 6.3850773
        }
      ],
      listPolyg: [],
      newUsers: [],
      mapaInstance: null
    }
  },
  created () {
    if (localStorage.getItem('usuarios')) {
      this.usuarios = JSON.parse(localStorage.getItem('usuarios'))
      this.dibujarServicios()
      this.consultarAgregarDiferentes()
    } else {
      axios.get('https://mensajeria.guepardos.co/api/v2/metricas')
        .then(response => {
          this.usuarios = response.data
          localStorage.setItem('usuarios', JSON.stringify(this.usuarios))
          this.dibujarServicios()
        })
    }
    axios.get('https://mensajeria.guepardos.co/api/v2/primerTrimestre')
      .then(response => {
        const fristDate = moment(response.data[0].fechaRegistro)
        const difDate = moment().diff(fristDate, 'months')
        const trimestres = difDate / 3
        this.rangoTrimestres = Math.floor(trimestres)
        if (difDate % 3 > 0) {
          this.rangoTrimestres += 1
        }
        this.rangoTrimestres += 1
        this.trimestre = this.rangoTrimestres
      })
    loaded.then(() => {
      this.$refs.myMapService.$mapCreated.then(() => {
        this.mapaInstance = this.$refs.myMapService.$mapObject
        let src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml'
        this.kmlAreaMetropolitana = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: null
        })
      })
    })
  },
  mounted () {
    this.agregarFechaUltimoServicio()
  },
  methods: {
    dibujarServicios () {
      const totalFecha = this.usuarios.reduce((a, b) => {
        if (b.fechaUltimoServicio !== '-') {
          return a + 1
        }
        return a
      }, 0)
      if (this.usuarios.length !== totalFecha) {
        this.todasFechas = false
      }
      _.forEach(this.usuarios, element => {
        let iconName = require('../assets/markerLeve.png')
        let fechaServicio = (element.fechaUltimoServicio) ? element.fechaUltimoServicio : '-'
        if (element.fechaRegistro) {
          if (this.diferenciaFecha(element.fechaRegistro) > 30) {
            iconName = require('../assets/service.png')
          }
        }
        if (element.geo) {
          this.markers.push({
            position: {
              lat: parseFloat(element.geo.lat),
              lng: parseFloat(element.geo.lng)
            },
            id: element.id,
            infoText: `<strong>Nombre: </strong>${element.nombre}<br><strong>Fecha registro: </strong>${this.formatoFecha(element.fechaRegistro)}<br><strong>Fecha ultimo servicio: </strong>${fechaServicio}`,
            icon: iconName
          })
        }
      })
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    diferenciaFecha (fecha) {
      let today = moment()
      return today.diff(fecha, 'days')
    },
    async agregarFechaUltimoServicio () {
      for (let index = 0; index < this.usuarios.length; index++) {
        const usuario = this.usuarios[index]
        const today = moment()
        if (usuario.fechaUltimoServicio) {
          if (today.diff(usuario.fechaUltimoServicio, 'days') > 30) {
            const fechaUltimoServicio = await this.getLastDate(usuario.id)
            let indexUser = this.usuarios.findIndex(item => item.id === usuario.id)
            this.usuarios[indexUser].fechaUltimoServicio = fechaUltimoServicio
            let indexMarker = this.markers.findIndex(item => item.id === usuario.id)
            if (indexMarker !== -1) {
              this.markers[indexMarker].infoText = `<strong>Nombre: </strong>${usuario.nombre}<br><strong>Fecha registro: </strong>${this.formatoFecha(usuario.fechaRegistro)}<br><strong>Fecha ultimo servicio: </strong> ${fechaUltimoServicio}`
            }
          }
        } else {
          const fechaUltimoServicio = await this.getLastDate(usuario.id)
          this.$Progress.start()
          let indexUser = this.usuarios.findIndex(item => item.id === usuario.id)
          this.usuarios[indexUser].fechaUltimoServicio = fechaUltimoServicio
          let indexMarker = this.markers.findIndex(item => item.id === usuario.id)
          if (indexMarker !== -1) {
            this.markers[indexMarker].infoText = `<strong>Nombre: </strong>${usuario.nombre}<br><strong>Fecha registro: </strong>${this.formatoFecha(usuario.fechaRegistro)}<br><strong>Fecha ultimo servicio: </strong>${fechaUltimoServicio}`
          }
        }
      }
      console.log('finish')
      this.todasFechas = false
      localStorage.setItem('usuarios', JSON.stringify(this.usuarios))
      this.$Progress.finish()
    },
    getLastDate (id) {
      return axios.get(`https://mensajeria.guepardos.co/api/v2/ultimoServicio/${id}`)
        .then(response => {
          if (response.data.length > 0) {
            return response.data[0].fecha
          } else {
            return '-'
          }
        })
    },
    formatoFecha (fecha) {
      if (fecha) {
        return moment(fecha).format('DD-MM-YYYY HH:mm A')
      }
      return '-'
    },
    countdown () {
      this.remainingCount = this.maxCount - this.message.length
      this.hasError = this.remainingCount < 0
    },
    consultarAgregarDiferentes () {
      axios.get('https://mensajeria.guepardos.co/api/v2/metricasMonth')
        .then(response => {
          for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index]
            const aux = this.usuarios.filter(usuario => usuario.id === element.id)
            if (aux.length === 0) {
              this.usuarios.push(element)
              localStorage.setItem('usuarios', JSON.stringify(this.usuarios))
            }
          }
        })
    },
    examinarUsuarios () {
      if (this.prueba) {
        if (!this.celular) {
          this.notificacionCelular()
          return
        }
        if (!this.message) {
          this.notificacionMessage()
          return
        }
        const telefonos = this.celular.split(',')
        this.$Progress.start()
        axios.post('https://mensajeria.guepardos.co/api/v2/enviarSmsPrueba', {celulares: telefonos, mensaje: this.message})
          .then(response => {
            this.$Progress.finish()
            if (response.data.length === 0) {
              this.notificacionCError()
            }
            this.enviarNotificaciones(response.data)
          })
          .catch(() => {
            this.$Progress.finish()
            this.notificacionCError()
          })
        return
      }
      if (this.zonasSelected.length === 0 || !this.message) {
        this.notificacionInvalido()
        return
      }
      let usuariosPasan = []
      for (let index = 0; index < this.zonasSelected.length; index++) {
        const poli = this.listPolyg.find(o => o.numero === this.zonasSelected[index].value)
        console.log(this.zonasSelected[index].value)
        for (let index2 = 0; index2 < this.newUsers.length; index2++) {
          const element = this.newUsers[index2]
          if (element.geo) {
            const lanLng = new google.maps.LatLng(element.geo.lat, element.geo.lng)
            const isOnZone = google.maps.geometry.poly.containsLocation(lanLng, poli)
            if (isOnZone) {
              usuariosPasan.push(element)
            }
          }
        }
      }
      usuariosPasan = usuariosPasan.map(item => item.id)
      this.enviarNotificaciones(usuariosPasan)
      this.enviandoMensajes()
    },
    enviarNotificaciones (ids) {
      this.$Progress.start()
      console.log(ids)
      axios.post('https://mensajeria.guepardos.co/api/v2/enviarNotificacion', {usuarios: ids, mensaje: this.message})
        .then(response => {
          this.notificacionSuccess()
          this.$Progress.finish()
        })
        .catch(() => {
          console.log('error')
          this.$Progress.finish()
        })
    },
    filtrarUsuarios (inicio, fin) {
      return this.usuarios.filter(usuario => {
        if (moment(usuario.fechaRegistro).isBetween(inicio, fin)) {
          return usuario
        }
      })
    },
    filtrarUsuariosUltimo (inicio, fin) {
      return this.usuarios.filter(usuario => {
        if (moment(usuario.fechaUltimoServicio).isBetween(inicio, fin)) {
          return usuario
        }
      })
    },
    marcarZonas () {
      if (this.listPolyg.length === 0) {
        let laureles = new google.maps.Polygon({
          path: this.zonaLaureles,
          geodesic: true,
          strokeColor: '#0f9d58',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0f9d58',
          fillOpacity: 0.35,
          numero: 1
        })
        let centro = new google.maps.Polygon({
          path: this.zonaCentro,
          geodesic: true,
          strokeColor: '#f57c00',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#f57c00',
          fillOpacity: 0.35,
          numero: 2
        })
        let envigado = new google.maps.Polygon({
          path: this.zonaEnvigado,
          geodesic: true,
          strokeColor: '#9c27b0',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#9c27b0',
          fillOpacity: 0.35,
          numero: 4
        })
        let poblado = new google.maps.Polygon({
          path: this.zonaPoblado,
          geodesic: true,
          strokeColor: '#0097a7',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0097a7',
          fillOpacity: 0.35,
          numero: 3
        })
        let metro = new google.maps.Polygon({
          path: this.zonaMetro,
          geodesic: true,
          strokeColor: '#0097a7',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0097a7',
          fillOpacity: 0.35,
          numero: 5
        })
        laureles.setMap(this.$refs.myMapService.$mapObject)
        centro.setMap(this.$refs.myMapService.$mapObject)
        envigado.setMap(this.$refs.myMapService.$mapObject)
        poblado.setMap(this.$refs.myMapService.$mapObject)
        metro.setMap(this.$refs.myMapService.$mapObject)
        this.listPolyg.push(laureles)
        this.listPolyg.push(centro)
        this.listPolyg.push(poblado)
        this.listPolyg.push(envigado)
        this.listPolyg.push(metro)
      }
      return
    }
  },
  watch: {
    async trimestre (value) {
      this.trimestre = value
      const trimestre = (this.rangoTrimestres - 1) * 3
      let mes = (this.trimestre * 3) - 3
      mes = trimestre - mes
      const mesInicial = moment().subtract(mes, 'months').startOf('month')
      const mesFinal = moment(mesInicial).add(3, 'months').endOf('month')
      this.newUsers = await this.filtrarUsuarios(mesInicial, mesFinal)
      this.markers = []
      if (Number(this.trimestre) === 0) {
        return
      }
      if (Number(this.trimestre) === Number(this.rangoTrimestres)) {
        this.newUsers = this.usuarios
      }
      _.forEach(this.newUsers, element => {
        let fechaServicio = (element.fechaUltimoServicio) ? element.fechaUltimoServicio : '-'
        let iconName = require('../assets/markerLeve.png')
        if (element.fechaRegistro) {
          if (this.diferenciaFecha(element.fechaRegistro) > 30) {
            iconName = require('../assets/service.png')
          }
        }
        if (element.geo) {
          this.markers.push({
            position: {
              lat: parseFloat(element.geo.lat),
              lng: parseFloat(element.geo.lng)
            },
            id: element.id,
            infoText: `<strong>Nombre: </strong>${element.nombre}<br><strong>Fecha registro: </strong>${this.formatoFecha(element.fechaRegistro)}<br><strong>Fecha ultimo servicio: </strong>${fechaServicio}`,
            icon: iconName
          })
        }
      })
    },
    async trimestreServicio (value) {
      this.trimestreServicio = value
      const trimestre = (this.rangoTrimestres - 1) * 3
      let mes = (this.trimestreServicio * 3) - 3
      mes = trimestre - mes
      const mesInicial = moment().subtract(mes, 'months').startOf('month')
      const mesFinal = moment(mesInicial).add(3, 'months').endOf('month')
      this.newUsers = await this.filtrarUsuariosUltimo(mesInicial, mesFinal)
      this.markers = []
      if (Number(this.trimestreServicio) === 0) {
        return
      }
      if (Number(this.trimestreServicio) === Number(this.rangoTrimestres)) {
        this.newUsers = this.usuarios
      }
      _.forEach(this.newUsers, element => {
        let iconName = require('../assets/markerLeve.png')
        if (element.fechaUltimoServicio) {
          if (this.diferenciaFecha(element.fechaUltimoServicio) > 30) {
            iconName = require('../assets/service.png')
          }
        }
        if (element.geo) {
          this.markers.push({
            position: {
              lat: parseFloat(element.geo.lat),
              lng: parseFloat(element.geo.lng)
            },
            id: element.id,
            infoText: `<strong>Nombre: </strong>${element.nombre}<br><strong>Fecha registro: </strong>${this.formatoFecha(element.fechaRegistro)}<br><strong>Fecha ultimo servicio: </strong>${element.fechaUltimoServicio}`,
            icon: iconName
          })
        }
      })
    },
    async zonasSelected (value) {
      let marcar = await this.marcarZonas()
      for (let index = 0; index < this.listPolyg.length; index++) {
        const element = this.listPolyg[index]
        element.setMap(null)
      }
      for (let index = 0; index < this.zonasSelected.length; index++) {
        const element = this.zonasSelected[index]
        this.listPolyg[element.value - 1].setMap(this.$refs.myMapService.$mapObject)
      }
    },
    mensajePredefinido (value) {
      this.mensajePredefinido = value
      this.message = 'Tenemos un Guepardo en tu zona. Tus vueltas de mensajeria HOY mismo, desde 5.800 COP, Programalo aqui: '
    }
  },
  notifications: {
    notificacionCelular: {
      title: 'Celular Invalido',
      message: 'Introduce un número de celular valido.',
      type: 'info',
      timeout: 9000
    },
    notificacionCError: {
      title: 'Celular Invalido',
      message: 'No se encontro ningun usuario con ese número de celular.',
      type: 'error',
      timeout: 9000
    },
    notificacionMessage: {
      title: 'Mensaje Invalido',
      message: 'Introduce un mensaje valido.',
      type: 'info',
      timeout: 9000
    },
    notificacionSuccess: {
      title: 'Mensaje Enviado',
      message: 'Mensaje enviado correctamente.',
      type: 'info',
      timeout: 9000
    },
    enviandoMensajes: {
      title: 'Mensajes Enviados',
      message: 'Los mensajes serán enviados a los clientes filtrados.',
      type: 'success',
      timeout: 9000
    },
    notificacionInvalido: {
      title: 'Formulario invalido',
      message: 'Seleccione una zona y un mensaje valido.',
      type: 'error',
      timeout: 9000
    }
  },
  components: {
    Multiselect
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
.marker {
  float: right;
  position: relative;
  padding-right: 5px;
  z-index: 1;
}
.sizeA {
  color: #410099;
}
.gm-fullscreen-control {
  display: none;
}
.colorVerde {
    color: #5cb85c;
}
.conNav {
 height: 91vh;
}
.sinNav {
  height: 100vh;
}
.stroke {
  -webkit-text-stroke: 0.5px black;
  opacity: 0.8;
}
.purple.darken-4 {
    background-color: #410099 !important;
}
.labels{
    color: black;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    width: 100px;
}
.estilotextarea {
  width:400px;
  height:100px;
  border: 1px solid #26a69a;
}
</style>



// WEBPACK FOOTER //
// Metrics.vue?6d83da4e